import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.qa');
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-qa',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.qa/view.scss */
@keyframes literature-modal-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes literature-modal-pop {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes literature-modal-icon-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}
.literature-modal-backdrop {
  animation: literature-modal-fade 160ms ease-out both;
}

.literature-folder-modal {
  animation: literature-modal-pop 220ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.literature-collection-modal {
  animation: literature-modal-pop 240ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.literature-folder-modal__icon {
  animation: literature-modal-icon-float 1.6s ease-in-out infinite;
}

.literature-collection-modal__icon {
  animation: literature-modal-icon-float 1.6s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .literature-modal-backdrop,
  .literature-folder-modal,
  .literature-collection-modal,
  .literature-folder-modal__icon,
  .literature-collection-modal__icon {
    animation: none;
  }
}`],
})
export class PageQaComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public driveLoading: boolean = false;
    public uploading: boolean = false;
    public artifactBuilding: boolean = false;
    public datasetBuilding: boolean = false;
    public error: string = '';
    public uploadMessage: string = '';

    public collections: any[] = [];
    public collectionQuery: string = '';
    public collectionSaving: boolean = false;
    public collectionDeleting: boolean = false;
    public collectionReindexingId: string = '';
    public showCollectionForm: boolean = false;
    public editingCollection: any = null;
    public expandedCollectionId: string = '';
    public collectionActionMenuId: string = '';
    public collectionForm: any = { title: '', description: '' };
    public fileQuery: string = '';
    public fileTypeFilter: string = 'all';
    public fileTypeFilters: any[] = [
        { key: 'all', label: '전체' },
        { key: 'source', label: '원본 자료' },
        { key: 'metadata', label: '자료 정보' },
        { key: 'ocr', label: '텍스트 자료' },
        { key: 'embedding', label: '근거 자료' },
        { key: 'vector', label: '근거 색인' },
        { key: 'status', label: '점검 상태' },
        { key: 'unregistered', label: '원본 확보 전' },
        { key: 'error', label: '오류' },
    ];
    public current: any = null;
    public health: any = { status: 'empty', cards: [], queue: [], summary: {} };
    public readiness: any = { status: 'attention', summary: {}, documents: [], total: 0, listed: 0, truncated: false };
    public root: string = '';
    public currentPath: string = '';
    public currentFolderId: string = '';
    public breadcrumbs: any[] = [];
    public folders: any[] = [];
    public files: any[] = [];
    public bundles: any[] = [];
    public exists: boolean = true;
    public truncated: boolean = false;
    public selected: any = null;
    public newFolderName: string = '';
    public driveActionMenuOpen: boolean = false;
    public showNewFolderForm: boolean = false;
    public uploadStatus: any = { uploading: false, percent: 0 };
    public driveInitialVisibleLimit: number = 20;
    public drivePageSize: number = 10;
    public driveVisibleLimit: number = 20;
    public driveIncrementLoading: boolean = false;

    public task: string = 'drive';
    private routerSub: any = null;
    private lastDriveRouteKey: string = '';
    private driveIncrementTimer: any = null;
    private driveScrollContainer: any = null;
    private driveScrollHandler: any = null;

    public datasetLoading: boolean = false;
    public datasetSaving: boolean = false;
    public datasetReviewing: boolean = false;
    public candidateGenerating: boolean = false;
    public datasetMessage: string = '';
    public datasetError: string = '';
    public qaDatasets: any[] = [];
    public qaItems: any[] = [];
    public evidenceChunks: any[] = [];
    public datasetSummary: any = {};
    public candidateResult: any = null;
    public candidateLimit: number = 200;
    public datasetCollection: any = null;
    public selectedCollectionId: string = '';
    public selectedDatasetId: string = '';
    public selectedQaItemId: string = '';
    public qaQuery: string = '';
    public evidenceQuery: string = '';
    public itemStatusFilter: string = 'all';
    public splitFilter: string = 'all';
    public difficultyFilter: string = 'all';
    public datasetForm: any = { name: '', description: '', collection_id: '' };
    public showDatasetForm: boolean = false;
    public selectedChunk: any = null;
    public qaForm: any = this.emptyQaForm();

    public itemTypeOptions: any[] = [
        { key: 'qa', label: '일반 QA' },
        { key: 'extractive', label: '근거 추출형' },
        { key: 'definition', label: '정의형' },
        { key: 'comparison', label: '비교형' },
        { key: 'multiple_choice', label: '객관식' },
    ];
    public difficultyOptions: any[] = [
        { key: 'easy', label: '쉬움' },
        { key: 'medium', label: '보통' },
        { key: 'hard', label: '어려움' },
    ];
    public splitOptions: any[] = [
        { key: 'train', label: '작성용' },
        { key: 'eval', label: '평가용' },
        { key: 'golden', label: '골든셋' },
    ];
    public authorStatusOptions: any[] = [
        { key: 'draft', label: '초안' },
        { key: 'candidate', label: '후보' },
        { key: 'ready', label: '검수 준비' },
        { key: 'blocked', label: '보류' },
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( ElementRef)  private elementRef: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        if (this.isReviewerRole()) {
            this.service.href('/review');
            return;
        }
        this.task = 'dataset';
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd && location.pathname.indexOf('/qa') === 0) {
                await this.syncTask();
            }
        });
        this.bindDriveScrollContainer();
        await this.loadDatasetAuthoring();
    }

    public isReviewerRole() {
        return String(this.service.auth.session?.role || '').toLowerCase() === 'reviewer';
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.driveIncrementTimer) clearTimeout(this.driveIncrementTimer);
        this.unbindDriveScrollContainer();
    }

    public async load() {
        await this.loadDatasetAuthoring();
    }

    public currentTask() {
        return 'dataset';
    }

    public qaRouteCollectionId() {
        const params = new URLSearchParams(location.search || '');
        const queryCollectionId = this.decodeRouteValue(params.get('collection_id') || '');
        if (queryCollectionId) return queryCollectionId;
        const parts = (location.pathname || '').split('/').filter((part: string) => part);
        const qaIndex = parts.indexOf('qa');
        return qaIndex >= 0 ? this.decodeRouteValue(parts[qaIndex + 1] || '') : '';
    }

    public currentDriveRoute() {
        const params = new URLSearchParams(location.search || '');
        const parts = (location.pathname || '').split('/').filter((part: string) => part);
        const literatureIndex = parts.indexOf('literature');
        const pathCollectionId = literatureIndex >= 0 ? this.decodeRouteValue(parts[literatureIndex + 1] || '') : '';
        const pathDriveValue = literatureIndex >= 0 ? parts.slice(literatureIndex + 2).join('/') : '';
        const routeValue = this.normalizeDrivePath(pathDriveValue || '');
        const queryCollectionId = this.decodeRouteValue(params.get('collection_id') || '');
        const queryFolderId = this.decodeRouteValue(params.get('folder_id') || '');
        const queryPath = this.normalizeDrivePath(params.get('path') || '');
        const folderId = queryFolderId || routeValue;
        return {
            collectionId: pathCollectionId || queryCollectionId,
            folderId,
            path: queryPath || (folderId ? '' : routeValue),
        };
    }

    public isCollectionListRoute(route: any) {
        return !route?.collectionId && !route?.folderId && !route?.path;
    }

    public decodeRouteValue(value: any) {
        const text = String(value || '');
        try {
            return decodeURIComponent(text);
        } catch (error) {
            return text;
        }
    }

    public normalizeDrivePath(value: any) {
        return this.decodeRouteValue(value)
            .replace(/\\/g, '/')
            .replace(/^\/+|\/+$/g, '')
            .split('/')
            .filter((part: string) => part && part !== '.' && part !== '..')
            .join('/');
    }

    public isFolderId(value: any) {
        return /^[a-f0-9]{64}$/i.test(String(value || ''));
    }

    public driveNodeRouteKey(collectionId: any = '', folderId: any = '', path: any = '') {
        return `${String(collectionId || '')}::${this.normalizeDrivePath(path || folderId)}`;
    }

    public driveUrl(collectionId: any = '', folderId: any = '') {
        const id = this.decodeRouteValue(collectionId || this.current?.id || '');
        if (!id) return '/literature';
        const nodePath = this.normalizeDrivePath(folderId || '');
        return `/literature/${encodeURIComponent(id)}${nodePath ? `?path=${encodeURIComponent(nodePath)}` : ''}`;
    }

    public async openDriveRoute(collectionId: any = '', folderId: any = '', replace: boolean = false) {
        const targetCollectionId = this.decodeRouteValue(collectionId || this.current?.id || '');
        const nextPath = this.normalizeDrivePath(folderId || '');
        const url = this.driveUrl(targetCollectionId, nextPath);
        await this.loadDrive(targetCollectionId, '', nextPath);
        if (`${location.pathname}${location.search}` !== url) {
            if (replace) {
                window.history.replaceState({}, '', url);
            } else {
                window.history.pushState({}, '', url);
            }
            const wizRoute = (window as any).WizRoute;
            if (wizRoute?.segment) {
                wizRoute.segment.collection_id = targetCollectionId;
                wizRoute.segment.drive_path = nextPath;
            }
        }
    }

    public isDatasetTask() {
        return true;
    }

    public showTopHeader() {
        return false;
    }

    public async openCollectionList() {
        this.selected = null;
        this.current = null;
        this.currentPath = '';
        this.currentFolderId = '';
        this.fileQuery = '';
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        this.expandedCollectionId = '';
        this.collectionActionMenuId = '';
        const url = '/literature';
        if (`${location.pathname}${location.search}` !== url) {
            window.history.pushState({}, '', url);
        }
        const wizRoute = (window as any).WizRoute;
        if (wizRoute?.segment) {
            wizRoute.segment.collection_id = '';
            wizRoute.segment.drive_path = '';
        }
        await this.loadDrive('', '', '');
    }

    public pageTitle() {
        return this.isDatasetTask() ? 'QA 작성' : '자료 준비';
    }

    public pageCaption() {
        return '준비 완료된 근거 자료로 QA 후보 생성, 편집, 검수 요청, 평가/골든셋 연결을 진행합니다.';
    }

    public async syncTask() {
        const collectionId = this.qaRouteCollectionId();
        if (collectionId !== this.selectedCollectionId) {
            this.selectedCollectionId = collectionId;
            this.selectedDatasetId = '';
            this.selectedQaItemId = '';
            this.selectedChunk = null;
            this.candidateResult = null;
            this.datasetForm = { ...this.datasetForm, collection_id: collectionId };
            this.qaForm = { ...this.emptyQaForm(), collection_id: collectionId };
        }
        this.task = 'dataset';
        this.loading = true;
        this.datasetError = '';
        this.datasetMessage = '';
        await this.service.render();
        await this.loadDatasetAuthoring();
    }

    public async loadDrive(collectionId: any = '', folderId: any = '', path: any = null, refresh: boolean = false) {
        const nextPath = path === null || path === undefined ? this.currentPath : path;
        this.error = '';
        this.uploadMessage = '';
        this.driveLoading = !this.loading;
        await this.service.render();

        try {
            const params = {
                collection_id: collectionId || this.current?.id || '',
                folder_id: folderId || '',
                path: nextPath || '',
                refresh: refresh ? '1' : '',
            };
            const { code, data } = await wiz.call("drive", params);
            if (code === 200) {
                this.assignDrive(data || {});
            } else {
                this.error = data?.message || '드라이브 목록을 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '드라이브 목록을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            this.driveLoading = false;
            await this.service.render();
        }
    }

    public assignDrive(data: any) {
        this.collections = data.collections || this.collections || [];
        this.current = data.current || null;
        this.health = data.health || this.health || { status: 'empty', cards: [], queue: [], summary: {} };
        this.readiness = data.readiness || { status: 'attention', summary: {}, documents: [], total: 0, listed: 0, truncated: false };
        this.root = data.root || '';
        this.currentPath = data.path || '';
        this.currentFolderId = data.folder_id || data.current_node?.id || '';
        this.breadcrumbs = data.breadcrumbs || [];
        this.folders = data.folders || [];
        this.files = data.files || [];
        this.bundles = data.bundles || [];
        this.exists = data.exists !== false;
        this.truncated = data.truncated === true;
        this.lastDriveRouteKey = this.driveNodeRouteKey(this.current?.id || '', this.currentFolderId || '', this.currentPath || '');
        this.resetDriveItemWindow();
        if (this.selected) {
            if (this.selected.type === 'bundle') {
                const currentBundle = this.filteredBundles.find((bundle: any) => bundle.key === this.selected.key);
                this.selected = currentBundle ? { ...currentBundle, type: 'bundle' } : null;
            } else if (!this.files.find((file: any) => file.path === this.selected.path)) {
                this.selected = null;
            }
        }
    }

    public get visibleCollections() {
        const text = this.collectionQuery.trim().toLowerCase();
        if (!text) return this.collections;
        return this.collections.filter((collection: any) => this.matches(collection, text, ['title', 'id', 'source_path', 'description', 'status', 'qa_status']));
    }

    public get datasetCollectionOptions() {
        return (this.collections || []).filter((collection: any) => this.collectionQaAvailable(collection));
    }

    public collectionFlowExpanded(collection: any) {
        return !!collection?.id && this.expandedCollectionId === collection.id;
    }

    public async toggleCollectionFlow(collection: any) {
        if (!collection?.id) return;
        this.collectionActionMenuId = '';
        this.expandedCollectionId = this.collectionFlowExpanded(collection) ? '' : collection.id;
        await this.service.render();
    }

    public collectionActionMenuOpen(collection: any) {
        return !!collection?.id && this.collectionActionMenuId === collection.id;
    }

    public async toggleCollectionActionMenu(collection: any) {
        if (!collection?.id) return;
        this.expandedCollectionId = '';
        this.collectionActionMenuId = this.collectionActionMenuOpen(collection) ? '' : collection.id;
        await this.service.render();
    }

    public async closeCollectionActionMenu() {
        if (!this.collectionActionMenuId) return;
        this.collectionActionMenuId = '';
        await this.service.render();
    }

    public collectionStatus(collection: any) {
        return collection?.status || 'active';
    }

    public collectionDeletionRequested(collection: any) {
        const status = this.collectionStatus(collection);
        return status === 'deletion_requested' || status === 'archived';
    }

    public collectionPurpose(collection: any) {
        const description = String(collection?.description || '').trim();
        if (description && !this.isCollectionTechnicalSummary(description)) return description;
        return '목적 설명 미입력';
    }

    public isCollectionTechnicalSummary(value: any) {
        const text = String(value || '').trim();
        if (!text) return false;
        const keys = [
            'embedding', 'embedding_status', 'metadata_json', 'ocr', 'ocr_status',
            'other_file', 'source_pdf', 'vector_status',
        ];
        if (!(text.startsWith('{') && text.endsWith('}'))) return false;
        try {
            const parsed = JSON.parse(text);
            if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') return false;
            const parsedKeys = Object.keys(parsed);
            const knownCount = parsedKeys.filter((key: string) => keys.includes(key)).length;
            const numericCount = parsedKeys.filter((key: string) => Number.isFinite(Number(parsed[key]))).length;
            return knownCount >= 2 && numericCount === parsedKeys.length;
        } catch (error) {
            return keys.some((key: string) => text.indexOf(`"${key}"`) >= 0);
        }
    }

    public collectionDocumentCount(collection: any) {
        return Number(collection?.qa_bundle_total || collection?.qa_document_total || collection?.document_count || 0);
    }

    public collectionOriginalRegisteredCount(collection: any) {
        return Number(collection?.qa_original_registered_count || collection?.source_file_count || 0);
    }

    public collectionProcessingCount(collection: any) {
        return Number(collection?.qa_processing_count || 0);
    }

    public collectionAttentionCount(collection: any) {
        return Number(collection?.qa_attention_count || 0);
    }

    public collectionUnavailableCount(collection: any) {
        return Number(collection?.qa_unavailable_count || 0);
    }

    public collectionTextReadyCount(collection: any) {
        return Number(collection?.qa_text_ready_count || 0);
    }

    public collectionReviewRequiredCount(collection: any) {
        return this.collectionAttentionCount(collection) + this.collectionUnavailableCount(collection);
    }

    public collectionEvidenceReadyDocumentCount(collection: any) {
        return Number(collection?.qa_evidence_ready_document_count || collection?.qa_usable_count || 0);
    }

    public collectionEvidenceReadyCount(collection: any) {
        return Number(collection?.qa_eligible_evidence_total || collection?.qa_evidence_total || 0);
    }

    public normalizeH2GateStatus(status: any) {
        const value = String(status || '').trim();
        if (value === 'usable') return 'usable';
        if (value === 'attention' || value === 'unavailable') return 'attention';
        if (value === 'partial' || value === 'processing') return 'processing';
        return '';
    }

    public collectionH2GateStatus(collection: any) {
        if (!collection) return 'processing';
        if (this.collectionDeletionRequested(collection)) return 'attention';
        const declared = this.normalizeH2GateStatus(collection?.h2_gate_status || collection?.qa_h2_gate_status || collection?.qa_status);
        if (declared) return declared;
        const total = this.collectionDocumentCount(collection);
        if (total <= 0 || this.collectionReviewRequiredCount(collection) > 0) return 'attention';
        if (this.collectionTextReadyCount(collection) < total) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (this.collectionEvidenceReadyDocumentCount(collection) < total) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (Number(collection?.qa_vector_total || 0) <= 0) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        return 'usable';
    }

    public collectionH2GateLabel(collection: any) {
        const status = this.collectionH2GateStatus(collection);
        if (status === 'usable') return 'QA 작성 가능';
        if (status === 'attention') return '점검 필요';
        return '자료 처리 중';
    }

    public collectionH2GateReasons(collection: any) {
        const raw = collection?.h2_gate_reasons || collection?.qa_h2_gate_reasons || [];
        const reasons = Array.isArray(raw) ? raw : [raw];
        const cleaned = reasons.map((item: any) => String(item || '').trim()).filter((item: string) => item);
        if (cleaned.length > 0) return cleaned.map((item: string) => this.businessStatusText(item));
        const reason = String(collection?.h2_gate_reason || collection?.qa_h2_gate_reason || '').trim();
        if (reason) return [this.businessStatusText(reason)];
        return this.collectionReadinessGapItems(collection);
    }

    public collectionH2GateReason(collection: any) {
        if (this.collectionDeletionRequested(collection)) return '폐기 요청 상태';
        const reasons = this.collectionH2GateReasons(collection);
        return reasons[0] || (this.collectionH2GateStatus(collection) === 'usable' ? '준비 완료' : '준비 점검 필요');
    }

    public collectionSummaryItems(collection: any) {
        return [
            { key: 'documents', label: '원본 자료', value: this.collectionOriginalRegisteredCount(collection), status: this.collectionSourceStatus(collection) },
            { key: 'recognition', label: '텍스트 자료', value: this.collectionTextReadyCount(collection), status: this.collectionRecognitionStatus(collection) },
            { key: 'evidence', label: '근거 자료', value: this.collectionEvidenceReadyDocumentCount(collection), status: this.collectionEvidenceStatus(collection) },
            { key: 'review', label: '준비 점검', value: this.collectionReviewRequiredCount(collection), status: this.collectionReviewStatus(collection) },
        ];
    }

    public collectionOverviewCards() {
        const rows = this.collections || [];
        const registered = rows.reduce((total: number, collection: any) => total + this.collectionOriginalRegisteredCount(collection), 0);
        const textReady = rows.reduce((total: number, collection: any) => total + this.collectionTextReadyCount(collection), 0);
        const evidenceReady = rows.reduce((total: number, collection: any) => total + this.collectionEvidenceReadyDocumentCount(collection), 0);
        const needsReview = rows.reduce((total: number, collection: any) => {
            return total + this.collectionReviewRequiredCount(collection);
        }, 0);
        return [
            { label: '원본 자료', value: registered, sub: `컬렉션 ${this.number(rows.length)}개` },
            { label: '텍스트 자료', value: textReady, sub: '텍스트 자료 준비 완료' },
            { label: '근거 자료', value: evidenceReady, sub: 'QA 작성용 근거 자료' },
            { label: '준비 점검', value: needsReview, sub: '오류·보류·확인 필요 점검' },
        ];
    }

    public collectionInlineMetrics(collection: any) {
        return [
            { label: '원본 자료', value: this.collectionDocumentCount(collection) },
            { label: '근거 자료', value: this.collectionEvidenceReadyDocumentCount(collection) },
            { label: '처리 중', value: collection?.qa_processing_count || 0 },
            { label: '준비 점검', value: Number(collection?.qa_attention_count || 0) + Number(collection?.qa_unavailable_count || 0) },
        ];
    }

    public collectionCompactMetrics(collection: any) {
        return [
            {
                label: '원본 자료',
                value: this.collectionOriginalRegisteredCount(collection),
                unit: '건',
                sub: this.collectionSourceSummary(collection),
                status: this.collectionSourceStatus(collection),
            },
            {
                label: '텍스트 자료',
                value: this.collectionTextReadyCount(collection),
                unit: '건',
                sub: this.collectionRecognitionSubLabel(collection),
                status: this.collectionRecognitionStatus(collection),
            },
            {
                label: '근거 자료',
                value: this.collectionEvidenceReadyDocumentCount(collection),
                unit: '건',
                sub: this.collectionEvidenceSubLabel(collection),
                status: this.collectionEvidenceStatus(collection),
            },
            {
                label: '준비 점검',
                value: this.collectionReviewRequiredCount(collection),
                unit: '건',
                sub: this.collectionReviewSubLabel(collection),
                status: this.collectionReviewStatus(collection),
            },
        ];
    }

    public collectionPurposeReady(collection: any) {
        return this.collectionPurpose(collection) !== '목적 설명 미입력';
    }

    public collectionSourceSummary(collection: any) {
        const migrated = Number(collection?.qa_migrated_2025_count || 0);
        const uploaded = Number(collection?.qa_new_upload_count || 0);
        const total = this.collectionDocumentCount(collection);
        const registered = this.collectionOriginalRegisteredCount(collection);
        if (total <= 0) return '원본 자료 없음';
        return `원본 확보 ${this.number(registered)} / ${this.number(total)}건 · 2025 ${this.number(migrated)} · 신규 ${this.number(uploaded)}`;
    }

    public collectionSourceStatus(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const registered = this.collectionOriginalRegisteredCount(collection);
        if (total <= 0) return 'unavailable';
        if (registered <= 0) return 'processing';
        if (registered < total) return 'attention';
        return 'usable';
    }

    public collectionRecognitionStatus(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const ready = this.collectionTextReadyCount(collection);
        if (total <= 0) return 'unavailable';
        if (ready <= 0) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (this.collectionAttentionCount(collection) > 0) return 'attention';
        if (ready < total || this.collectionProcessingCount(collection) > 0) return 'processing';
        return 'usable';
    }

    public collectionEvidenceStatus(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const evidence = this.collectionEvidenceReadyDocumentCount(collection);
        if (total <= 0) return 'unavailable';
        if (evidence <= 0) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (this.collectionReviewRequiredCount(collection) > 0) return 'attention';
        if (evidence < total || this.collectionProcessingCount(collection) > 0) return 'processing';
        return 'usable';
    }

    public collectionReviewStatus(collection: any) {
        if (this.collectionReviewRequiredCount(collection) > 0) return 'attention';
        if (this.collectionProcessingCount(collection) > 0) return 'processing';
        return this.collectionDocumentCount(collection) > 0 ? 'usable' : 'unavailable';
    }

    public collectionRecognitionSubLabel(collection: any) {
        const total = this.collectionDocumentCount(collection);
        if (total <= 0) return '원본 자료 없음';
        const ready = this.collectionTextReadyCount(collection);
        if (ready <= 0) return '텍스트 자료 생성 중';
        if (this.collectionProcessingCount(collection) > 0) return `처리 중 ${this.number(this.collectionProcessingCount(collection))}건 포함`;
        return `준비 ${this.number(ready)} / ${this.number(total)}건`;
    }

    public collectionEvidenceSubLabel(collection: any) {
        const ready = this.collectionEvidenceReadyCount(collection);
        return ready > 0 ? `근거 자료 ${this.number(ready)}건` : '근거 자료 생성 중';
    }

    public collectionReviewSubLabel(collection: any) {
        if (collection?.h2_gate_reason || collection?.qa_h2_gate_reason) return this.collectionH2GateReason(collection);
        const attention = this.collectionAttentionCount(collection);
        const unavailable = this.collectionUnavailableCount(collection);
        const processing = this.collectionProcessingCount(collection);
        if (attention + unavailable > 0) return `점검 확인 ${this.number(attention)} · 준비 필요 ${this.number(unavailable)}`;
        if (processing > 0) return `처리 중 ${this.number(processing)}`;
        return this.collectionDocumentCount(collection) > 0 ? '준비 완료' : '원본 확보 후 확인';
    }

    public collectionReadinessSubLabel(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const usable = this.collectionEvidenceReadyDocumentCount(collection);
        if (this.collectionDeletionRequested(collection)) return '폐기 요청 상태';
        if (this.collectionH2GateStatus(collection) !== 'usable') return this.collectionH2GateReason(collection);
        if (total <= 0) return '원본 자료 없음';
        return `준비 완료 · 근거 ${this.number(usable)} / ${this.number(total)}건`;
    }

    public collectionFinalStatus(collection: any) {
        return this.collectionH2GateStatus(collection);
    }

    public collectionFinalStatusLabel(collection: any) {
        return this.collectionH2GateLabel(collection);
    }

    public collectionFinalStatusBadgeClass(collection: any) {
        const status = this.collectionFinalStatus(collection);
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'attention') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public collectionReadinessGapItems(collection: any) {
        const declared = collection?.h2_gate_reasons || collection?.qa_h2_gate_reasons;
        if (Array.isArray(declared) && declared.length > 0) {
            return declared.map((item: any) => this.businessStatusText(item)).filter((item: string) => item);
        }
        const gaps: string[] = [];
        const total = this.collectionDocumentCount(collection);
        const registered = this.collectionOriginalRegisteredCount(collection);
        const textReady = this.collectionTextReadyCount(collection);
        const evidenceReady = this.collectionEvidenceReadyDocumentCount(collection);
        const review = this.collectionReviewRequiredCount(collection);
        const processing = this.collectionProcessingCount(collection);

        if (this.collectionDeletionRequested(collection)) gaps.push('폐기 요청 상태');
        if (total <= 0) {
            gaps.push('원본 자료 필요');
        } else {
            if (registered < total) gaps.push(`원본 자료 ${this.number(total - registered)}건 부족`);
            if (textReady < total) gaps.push(`텍스트 자료 ${this.number(total - textReady)}건 부족`);
            if (evidenceReady < total) gaps.push(`근거 자료 ${this.number(total - evidenceReady)}건 부족`);
        }
        if (review > 0) gaps.push(`준비 점검 ${this.number(review)}건`);
        if (processing > 0 && gaps.length === 0) gaps.push(`처리 중 ${this.number(processing)}건`);
        return gaps;
    }

    public collectionReadyForQaAuthoring(collection: any) {
        return this.collectionFinalStatus(collection) === 'usable';
    }

    public collectionHeaderBadges(collection: any) {
        return [{
            label: this.collectionFinalStatusLabel(collection),
            status: this.collectionFinalStatus(collection),
        }];
    }

    public collectionFlowItems(collection: any) {
        const total = this.collectionDocumentCount(collection);
        return [
            {
                label: '원본 확보',
                value: `${this.number(this.collectionOriginalRegisteredCount(collection))} / ${this.number(total)}건`,
                sub: this.collectionSourceSummary(collection),
                status: this.collectionSourceStatus(collection),
            },
            {
                label: '텍스트 자료',
                value: `${this.number(this.collectionTextReadyCount(collection))}건`,
                sub: this.collectionRecognitionSubLabel(collection),
                status: this.collectionRecognitionStatus(collection),
            },
            {
                label: '근거 자료',
                value: `${this.number(this.collectionEvidenceReadyDocumentCount(collection))}건`,
                sub: this.collectionEvidenceSubLabel(collection),
                status: this.collectionEvidenceStatus(collection),
            },
            {
                label: '준비 점검',
                value: `${this.number(this.collectionReviewRequiredCount(collection))}건`,
                sub: this.collectionReviewSubLabel(collection),
                status: this.collectionReviewStatus(collection),
            },
        ];
    }

    public collectionTechnicalDiagnosticItems(collection: any) {
        return [
            {
                label: '텍스트 단위',
                value: `${this.number(collection?.qa_chunk_total || 0)}개`,
                sub: '근거 자료 구성 단위',
            },
            {
                label: '근거 후보',
                value: `${this.number(collection?.qa_evidence_total || collection?.qa_eligible_evidence_total || 0)}개`,
                sub: '근거 자료 후보',
            },
            {
                label: '근거 색인',
                value: `${this.number(collection?.qa_vector_total || 0)}개`,
                sub: 'QA 검색 연결 완료',
            },
        ];
    }


    public collectionStatusDotClass(status: string) {
        if (status === 'usable') return 'bg-emerald-500';
        if (status === 'partial') return 'bg-sky-500';
        if (status === 'processing') return 'bg-amber-500';
        if (status === 'attention') return 'bg-rose-500';
        return 'bg-gray-400';
    }

    public collectionSoftStatusClass(status: string) {
        if (status === 'usable') return 'bg-emerald-50 text-emerald-700';
        if (status === 'partial') return 'bg-sky-50 text-sky-700';
        if (status === 'processing') return 'bg-amber-50 text-amber-700';
        if (status === 'attention') return 'bg-rose-50 text-rose-700';
        return 'bg-gray-100 text-gray-600';
    }

    public collectionStatusTextClass(status: string) {
        if (status === 'usable') return 'text-emerald-700';
        if (status === 'partial') return 'text-sky-700';
        if (status === 'processing') return 'text-amber-700';
        if (status === 'attention') return 'text-rose-700';
        return 'text-gray-500';
    }

    public collectionMetricCardClass(status: string) {
        if (status === 'usable') return 'border-emerald-100 bg-emerald-50/60';
        if (status === 'partial') return 'border-sky-100 bg-sky-50/60';
        if (status === 'processing') return 'border-amber-100 bg-amber-50/60';
        if (status === 'attention') return 'border-rose-100 bg-rose-50/60';
        return 'border-gray-100 bg-gray-50';
    }

    public collectionBlockerStatus(collection: any) {
        if (this.collectionAttentionCount(collection) > 0) return 'attention';
        if (this.collectionProcessingCount(collection) > 0) return 'processing';
        if (this.collectionUnavailableCount(collection) > 0) return 'unavailable';
        if (this.collectionEvidenceReadyDocumentCount(collection) > 0) return 'usable';
        return 'unavailable';
    }

    public collectionBlockerLabel(collection: any) {
        const attention = this.collectionAttentionCount(collection);
        const processing = this.collectionProcessingCount(collection);
        const unavailable = this.collectionUnavailableCount(collection);
        const usable = this.collectionEvidenceReadyDocumentCount(collection);
        if (attention > 0) return `확인 필요 ${this.number(attention)}건`;
        if (processing > 0) return `처리 중 ${this.number(processing)}건`;
        if (unavailable > 0) return `자료 준비 필요 ${this.number(unavailable)}건`;
        if (usable > 0) return '막힘 없음';
        return '자료 등록 필요';
    }

    public collectionQaAvailable(collection: any) {
        if (this.collectionDeletionRequested(collection)) return false;
        return this.collectionReadyForQaAuthoring(collection);
    }

    public collectionQaAvailabilityStatus(collection: any) {
        if (this.collectionDeletionRequested(collection)) return 'processing';
        const status = String(collection?.qa_status || '').trim();
        if (['usable', 'partial', 'processing', 'attention'].includes(status)) return status;
        if (this.collectionQaAvailable(collection)) return 'usable';
        return 'processing';
    }

    public collectionQaAvailabilityLabel(collection: any) {
        return this.collectionReadinessLabel(collection);
    }

    public collectionReadinessLabel(collection: any) {
        if (this.collectionDeletionRequested(collection)) return '폐기 요청됨';
        return this.collectionFinalStatusLabel(collection);
    }

    public collectionReadinessSummary(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const usable = this.collectionEvidenceReadyDocumentCount(collection);
        const status = this.collectionFinalStatus(collection);
        if (this.collectionDeletionRequested(collection)) return '폐기 요청 상태';
        if (status === 'usable') return `QA 작성 가능 ${this.number(usable)} / ${this.number(total)}건`;
        const gaps = this.collectionReadinessGapItems(collection);
        return gaps.length ? gaps.slice(0, 2).join(' · ') : '준비 중';
    }

    public collectionImmediateDeleteAvailable(collection: any) {
        if (this.collectionDeletionRequested(collection)) return false;
        const qaTotal = Number(collection?.qa_usable_count || 0)
            + Number(collection?.qa_processing_count || 0)
            + Number(collection?.qa_attention_count || 0)
            + Number(collection?.qa_unavailable_count || 0);
        return this.collectionDocumentCount(collection) <= 0
            && Number(collection?.file_count || 0) <= 0
            && qaTotal <= 0;
    }

    public collectionDeleteActionLabel(collection: any) {
        if (this.collectionDeletionRequested(collection)) return '요청 취소';
        if (this.collectionImmediateDeleteAvailable(collection)) return '삭제';
        return '폐기 요청';
    }

    public collectionDeleteActionClass(collection: any) {
        if (this.collectionDeletionRequested(collection)) return 'border-gray-300 text-gray-700 hover:bg-gray-50';
        return 'border-rose-200 text-rose-700 hover:bg-rose-50';
    }

    public collectionEvidenceLabel(collection: any) {
        return `텍스트 자료 ${this.number(this.collectionTextReadyCount(collection))}건 · 근거 자료 ${this.number(this.collectionEvidenceReadyDocumentCount(collection))}건 · QA 작성용 근거 ${this.number(this.collectionEvidenceReadyCount(collection))}건`;
    }

    public get filteredFolders() {
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return this.folders;
        return this.folders.filter((folder: any) => this.matches(folder, text, ['name', 'path', 'id']));
    }

    public get visibleFolders() {
        return this.filteredFolders.slice(0, this.driveVisibleLimit);
    }

    public filesMatchingQuery() {
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return this.files;
        return this.files.filter((file: any) => this.matches(file, text, [
            'name', 'path', 'extension', 'file_role', 'parse_status',
            'document_title', 'metadata_title', 'artifact_status',
            'ocr_status', 'embedding_status', 'vector_status', 'quality_status',
            'source_mode', 'source_mode_label',
        ]));
    }

    public get filteredBundles() {
        return this.allBundles()
            .filter((bundle: any) => this.isPrimaryBundle(bundle))
            .filter((bundle: any) => this.bundleMatchesQuery(bundle))
            .filter((bundle: any) => this.bundleMatchesType(bundle, this.fileTypeFilter))
            .sort((a: any, b: any) => a.title.localeCompare(b.title));
    }

    public get visibleBundles() {
        return this.filteredBundles.slice(0, this.driveSecondaryVisibleLimit());
    }

    public get driveTotalItems() {
        return this.filteredFolders.length + this.filteredBundles.length;
    }

    public get hasMoreDriveItems() {
        return this.driveVisibleLimit < this.driveTotalItems;
    }

    public driveSecondaryVisibleLimit() {
        return Math.max(0, this.driveVisibleLimit - this.filteredFolders.length);
    }

    public resetDriveItemWindow() {
        this.driveVisibleLimit = this.driveInitialVisibleLimit;
        this.driveIncrementLoading = false;
        if (this.driveIncrementTimer) {
            clearTimeout(this.driveIncrementTimer);
            this.driveIncrementTimer = null;
        }
    }

    public async setFileQuery(value: any) {
        this.fileQuery = String(value || '');
        this.resetDriveItemWindow();
        await this.service.render();
    }

    public bindDriveScrollContainer() {
        if (this.driveScrollHandler) return;
        this.driveScrollHandler = () => {
            this.loadMoreDriveItemsOnScroll();
        };
        setTimeout(() => {
            if (!this.driveScrollHandler) return;
            const container = this.findDriveScrollContainer();
            this.driveScrollContainer = container;
            if (container === window) {
                window.addEventListener('scroll', this.driveScrollHandler, { passive: true });
            } else if (container?.addEventListener) {
                container.addEventListener('scroll', this.driveScrollHandler, { passive: true });
            }
            window.addEventListener('resize', this.driveScrollHandler, { passive: true });
            this.driveScrollHandler();
        }, 0);
    }

    public unbindDriveScrollContainer() {
        if (!this.driveScrollHandler) return;
        if (this.driveScrollContainer === window) {
            window.removeEventListener('scroll', this.driveScrollHandler);
        } else if (this.driveScrollContainer?.removeEventListener) {
            this.driveScrollContainer.removeEventListener('scroll', this.driveScrollHandler);
        }
        window.removeEventListener('resize', this.driveScrollHandler);
        this.driveScrollContainer = null;
        this.driveScrollHandler = null;
    }

    public findDriveScrollContainer() {
        let node = this.elementRef?.nativeElement?.parentElement || null;
        while (node && node !== document.body) {
            const style = window.getComputedStyle(node);
            const overflowY = `${style.overflowY || style.overflow || ''}`.toLowerCase();
            if (overflowY.indexOf('auto') >= 0 || overflowY.indexOf('scroll') >= 0) {
                return node;
            }
            node = node.parentElement;
        }
        return window;
    }

    public driveScrollMetrics() {
        const container = this.driveScrollContainer || this.findDriveScrollContainer();
        if (container && container !== window) {
            return {
                scrollTop: Number(container.scrollTop || 0),
                viewportHeight: Number(container.clientHeight || 0),
                scrollHeight: Number(container.scrollHeight || 0),
            };
        }
        const doc = document.documentElement;
        const body = document.body;
        return {
            scrollTop: window.pageYOffset || doc.scrollTop || body.scrollTop || 0,
            viewportHeight: window.innerHeight || doc.clientHeight || 0,
            scrollHeight: Math.max(
                body.scrollHeight,
                doc.scrollHeight,
                body.offsetHeight,
                doc.offsetHeight,
                body.clientHeight,
                doc.clientHeight,
            ),
        };
    }

    public async loadMoreDriveItemsOnScroll() {
        if (this.loading || this.driveLoading || this.driveIncrementLoading) return;
        if (!this.current || !this.exists || !this.hasMoreDriveItems) return;
        const { scrollTop, viewportHeight, scrollHeight } = this.driveScrollMetrics();
        if (scrollTop + viewportHeight < scrollHeight - 160) return;

        this.driveIncrementLoading = true;
        await this.service.render();
        this.driveIncrementTimer = setTimeout(async () => {
            this.driveVisibleLimit = Math.min(this.driveVisibleLimit + this.drivePageSize, this.driveTotalItems);
            this.driveIncrementLoading = false;
            this.driveIncrementTimer = null;
            await this.service.render();
        }, 260);
    }

    public isPrimaryBundle(bundle: any) {
        if (Number(bundle?.source?.length || 0) > 0) return true;
        if (this.bundleDocumentId(bundle)) return true;
        const files = bundle?.files || [];
        return files.some((file: any) => {
            const meta = this.classifyFile(file);
            const ext = String(file?.extension || '').toLowerCase();
            const technical = ['metadata', 'ocr', 'embedding', 'vector', 'status', 'ocr_status', 'embedding_status', 'vector_status'].includes(meta.role);
            return !technical && ext !== 'json';
        });
    }

    public allBundles() {
        if ((this.bundles || []).length > 0) {
            return this.bundles.map((bundle: any) => this.prepareBundle({ ...bundle }));
        }
        const map: any = {};
        for (const file of this.files) {
            const meta = this.classifyFile(file);
            const key = `${meta.dir}/${meta.base}`;
            if (!map[key]) {
                map[key] = {
                    key,
                    title: meta.base,
                    dir: meta.dir,
                    source: [],
                    metadata: [],
                    ocr: [],
                    embedding: [],
                    vector: [],
                    status: [],
                    ocr_status: [],
                    embedding_status: [],
                    vector_status: [],
                    other: [],
                    files: [],
                    slots: [],
                    source_mode: '',
                    source_mode_label: '',
                };
            }
            const role = map[key][meta.role] ? meta.role : 'other';
            map[key][role].push(file);
            if (role === 'metadata' && file?.metadata_title) {
                map[key].metadata_title = file.metadata_title;
            }
            if (['ocr_status', 'embedding_status', 'vector_status'].includes(role)) {
                map[key].status.push(file);
            }
            if (!map[key].source_mode && file?.source_mode) {
                map[key].source_mode = file.source_mode;
                map[key].source_mode_label = file.source_mode_label || this.sourceModeLabel(file.source_mode);
            }
            map[key].files.push(file);
        }

        return Object.values(map).map((bundle: any) => this.prepareBundle(bundle));
    }

    public prepareBundle(bundle: any) {
        for (const key of ['source', 'metadata', 'ocr', 'embedding', 'vector', 'status', 'ocr_status', 'embedding_status', 'vector_status', 'other', 'files']) {
            if (!bundle[key]) bundle[key] = [];
        }
        const statusFiles = this.statusFiles(bundle);
        const registeredSource = (bundle.source || []).find((file: any) => file?.registered);
        if (registeredSource && !bundle.metadata.length) {
            bundle.metadata.push({
                virtual: true,
                name: '자료 정보',
                metadata_title: registeredSource.document_title || bundle.title,
                artifact_status: 'ready',
                parse_status: 'ready',
            });
        }
        if (!bundle.source_mode) {
            const source = (bundle.source || []).find((file: any) => file?.source_mode);
            bundle.source_mode = source?.source_mode || (registeredSource ? 'migrated_2025' : '');
            bundle.source_mode_label = source?.source_mode_label || this.sourceModeLabel(bundle.source_mode);
        }
        bundle.slots = [
            { key: 'source', label: '원본 자료', files: bundle.source, required: true },
            { key: 'metadata', label: '자료 정보', files: bundle.metadata, required: true },
            { key: 'ocr', label: '텍스트 자료', files: bundle.ocr, required: false },
            { key: 'embedding', label: '근거 자료', files: bundle.embedding, required: false },
            { key: 'vector', label: '근거 색인', files: bundle.vector, required: false },
            { key: 'status', label: '점검 상태', files: statusFiles, required: false },
        ];
        bundle.missing = bundle.slots.filter((slot: any) => slot.required && slot.files.length === 0).length;
        bundle.ocr_page_count = this.bundleCountValue(bundle, 'ocr_page_count');
        bundle.embedding_chunk_count = this.bundleCountValue(bundle, 'embedding_chunk_count');
        bundle.vector_count = this.bundleCountValue(bundle, 'vector_count');
        bundle.vector_inserted_count = this.bundleCountValue(bundle, 'vector_inserted_count');
        bundle.evidence_count = this.bundleCountValue(bundle, 'evidence_count');
        bundle.eligible_evidence_count = this.bundleCountValue(bundle, 'eligible_evidence_count');
        bundle.qa_status = bundle.qa_status || this.bundleQaStatus(bundle);
        bundle.qa_reason = bundle.qa_reason || this.bundleQaReason(bundle);
        return bundle;
    }

    public bundleMatchesQuery(bundle: any) {
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return true;
        if (this.matches(bundle, text, ['title', 'dir', 'metadata_title', 'qa_status', 'qa_reason', 'source_mode', 'source_mode_label'])) return true;
        return (bundle?.files || []).some((file: any) => this.matches(file, text, [
            'name', 'path', 'extension', 'file_role', 'parse_status',
            'document_title', 'metadata_title', 'artifact_status',
            'ocr_status', 'embedding_status', 'vector_status', 'quality_status',
            'source_mode', 'source_mode_label',
        ]));
    }

    public bundleMatchesType(bundle: any, key: string) {
        if (!key || key === 'all') return true;
        if (key === 'source') return Number(bundle?.source?.length || 0) > 0;
        if (key === 'metadata') return Number(bundle?.metadata?.length || 0) > 0;
        if (key === 'ocr') return Number(bundle?.ocr?.length || 0) > 0;
        if (key === 'embedding') return Number(bundle?.embedding?.length || 0) > 0;
        if (key === 'vector') return Number(bundle?.vector?.length || 0) > 0 || Number(bundle?.vector_status?.length || 0) > 0;
        if (key === 'status') return this.statusFiles(bundle).length > 0;
        if (key === 'unregistered') return this.bundleUnregisteredSourceCount(bundle) > 0;
        if (key === 'error') return this.bundleErrorCount(bundle) > 0 || this.bundleQaStatus(bundle) === 'attention';
        return true;
    }

    public bundleMax(bundle: any, key: string) {
        const values = (bundle?.files || []).map((file: any) => Number(file?.[key] !== undefined ? file?.[key] : (file?.artifact_summary?.[key] || 0)));
        return values.length ? Math.max(...values, 0) : 0;
    }

    public bundleCountValue(bundle: any, key: string) {
        const dbValues = (bundle?.files || [])
            .filter((file: any) => file?.document_id && file?.[key] !== undefined && file?.[key] !== null && file?.[key] !== '')
            .map((file: any) => Number(file?.[key] || 0));
        if (dbValues.length) return Math.max(...dbValues, 0);
        const direct = Number(bundle?.[key] || 0);
        const fallback = this.bundleMax(bundle, key);
        return Math.max(Number.isFinite(direct) ? direct : 0, fallback);
    }

    public bundleStatusValues(bundle: any, key: string = '') {
        const values: string[] = [];
        for (const file of bundle?.files || []) {
            values.push(...this.fileStatusValues(file));
        }
        if (key) {
            for (const file of bundle?.[key] || []) {
                values.push(String(file?.artifact_status || '').toLowerCase());
            }
            const statusKey = key === 'ocr' ? 'ocr_status' : (key === 'embedding' ? 'embedding_status' : (key === 'vector' ? 'vector_status' : ''));
            if (statusKey) {
                values.push(...(bundle?.[statusKey] || []).map((file: any) => String(file?.artifact_status || '').toLowerCase()));
            }
        }
        return values.filter((value: string) => value);
    }

    public hasWorkingStatus(bundle: any, key: string = '') {
        return this.bundleStatusValues(bundle, key).some((status: string) => ['pending', 'queued', 'running', 'working', 'processing'].includes(status));
    }

    public bundleQaStatus(bundle: any) {
        if (bundle?.bundle_status) return bundle.bundle_status;
        if (this.bundleErrorCount(bundle) > 0) return 'attention';
        if (Number(bundle?.source?.length || 0) <= 0) return 'unavailable';
        if (!this.bundleDocumentId(bundle)) return 'unavailable';
        if (Number(bundle?.metadata?.length || 0) <= 0) return 'unavailable';
        if (Number(bundle?.ocr_page_count || 0) <= 0) return 'processing';
        if (Number(bundle?.embedding_chunk_count || 0) <= 0) return 'processing';
        if (Number(bundle?.vector_inserted_count || 0) <= 0) return 'processing';
        if (Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) <= 0) return 'processing';
        return 'usable';
    }

    public bundleQaReason(bundle: any) {
        if (bundle?.review_required) return '준비 점검이 필요한 자료가 있습니다.';
        if (bundle?.qa_evidence_ready) return 'QA 작성에 사용할 근거 자료가 준비되었습니다.';
        if (bundle?.text_ready) return '근거 자료 생성 중입니다.';
        if (bundle?.original_registered) return '텍스트 자료 생성 중입니다.';
        if (this.bundleErrorCount(bundle) > 0) return '처리 오류 상태가 있는 자료를 확인해야 합니다.';
        if (Number(bundle?.source?.length || 0) <= 0) return '원본 자료가 없습니다.';
        if (!this.bundleDocumentId(bundle)) return '자료 정보 연결이 필요합니다.';
        if (Number(bundle?.metadata?.length || 0) <= 0) return '자료 정보 연결이 필요합니다.';
        if (Number(bundle?.ocr_page_count || 0) <= 0) return '텍스트 자료 생성 중입니다.';
        if (Number(bundle?.embedding_chunk_count || 0) <= 0) return '근거 자료 생성 중입니다.';
        if (Number(bundle?.vector_inserted_count || 0) <= 0) return '근거 색인 중입니다.';
        if (Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) <= 0) return '근거 색인 중입니다.';
        return 'QA 작성에 사용할 근거 자료가 준비되었습니다.';
    }

    public bundleDocumentId(bundle: any) {
        const file = (bundle?.files || []).find((item: any) => String(item?.document_id || '').trim());
        return file?.document_id || '';
    }

    public bundleQaStatusLabel(bundle: any) {
        switch (bundle?.qa_status || this.bundleQaStatus(bundle)) {
            case 'usable':
                return '근거 자료 준비';
            case 'partial':
                return '부분 준비';
            case 'processing':
                return '준비 중';
            case 'unavailable':
                return '준비 중';
            default:
                return '점검 필요';
        }
    }

    public bundleProcessingStatus(bundle: any) {
        if (bundle?.bundle_status) return bundle.bundle_status;
        if (this.bundleErrorCount(bundle) > 0) return 'attention';
        if (Number(bundle?.source?.length || 0) <= 0) return 'unavailable';
        if (!this.bundleDocumentId(bundle) || Number(bundle?.metadata?.length || 0) <= 0) return 'pending';
        const statuses = ['ocr', 'chunk', 'vector', 'evidence'].map((key: string) => this.bundleStageStatus(bundle, key));
        if (statuses.includes('processing')) return 'processing';
        if (statuses.every((status: string) => status === 'usable')) return 'usable';
        return 'attention';
    }

    public bundleProcessingStatusLabel(bundle: any) {
        switch (this.bundleProcessingStatus(bundle)) {
            case 'usable':
                return 'QA 작성 가능';
            case 'processing':
                return '준비 중';
            case 'pending':
                return '준비 중';
            case 'unavailable':
                return '준비 중';
            default:
                return '점검 필요';
        }
    }

    public bundleProcessingStatusClass(bundle: any) {
        return this.statusClass(this.bundleProcessingStatus(bundle));
    }

    public readinessStepClass(status: string) {
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'processing') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === 'unavailable') return 'border-gray-200 bg-gray-50 text-gray-600';
        return 'border-rose-200 bg-rose-50 text-rose-700';
    }

    public get healthCards() {
        return this.health?.cards || [];
    }

    public get queueItems() {
        return this.health?.queue || [];
    }

    public get pipelineItems() {
        return this.health?.pipeline || [];
    }

    public get healthSummary() {
        return this.health?.summary || {};
    }

    public get readinessSummary() {
        return this.readiness?.summary || {};
    }

    public get readinessCards() {
        const summary = this.readinessSummary;
        return [
            { key: 'usable', label: 'QA 작성 가능', value: summary.usable_count || 0, status: 'usable' },
            { key: 'processing', label: '준비 중', value: summary.processing_count || 0, status: 'processing' },
            { key: 'attention', label: '준비 점검', value: summary.attention_count || 0, status: 'attention' },
            { key: 'unavailable', label: '준비 중', value: summary.unavailable_count || 0, status: 'unavailable' },
        ];
    }

    public get readinessArtifactCards() {
        const summary = this.readinessSummary;
        return [
            { label: '텍스트 자료', value: summary.ocr_page_total || 0 },
            { label: '근거 자료', value: summary.eligible_evidence_total || summary.evidence_total || 0 },
            { label: 'QA 작성 가능', value: summary.usable_count || 0 },
            { label: '준비 점검', value: summary.attention_count || 0 },
        ];
    }

    public get visibleReadinessDocuments() {
        const rows = this.readiness?.documents || [];
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return rows;
        return rows.filter((row: any) => this.matches(row, text, [
            'title', 'document_key', 'relative_dir', 'source_type',
            'qa_status', 'qa_reason', 'ocr_status', 'embedding_status', 'vector_status', 'quality_status',
        ]));
    }

    public get localUnregisteredCount() {
        return this.files.filter((file: any) => !file.registered).length;
    }

    public get currentFileStats() {
        const files = this.filesMatchingQuery();
        return {
            source: files.filter((file: any) => this.matchesFileType(file, 'source')).length,
            metadata: files.filter((file: any) => this.matchesFileType(file, 'metadata')).length,
            ocr: files.filter((file: any) => this.matchesFileType(file, 'ocr')).length,
            embedding: files.filter((file: any) => this.matchesFileType(file, 'embedding')).length,
            vector: files.filter((file: any) => this.matchesFileType(file, 'vector')).length,
            status: files.filter((file: any) => this.matchesFileType(file, 'status')).length,
            unregistered: files.filter((file: any) => this.matchesFileType(file, 'unregistered')).length,
            error: files.filter((file: any) => this.matchesFileType(file, 'error')).length,
        };
    }

    public classifyFile(file: any) {
        const filepath = String(file?.path || file?.name || '');
        const parts = filepath.split('/');
        const filename = parts.pop() || String(file?.name || '');
        const dir = parts.join('/');
        const lower = filename.toLowerCase();
        const ext = String(file?.extension || '').toLowerCase();
        const withoutExt = filename.replace(/\.[^/.]+$/, '');
        const role = String(file?.file_role || '').toLowerCase();
        const artifactKind = String(file?.artifact_kind || '').toLowerCase();
        if (artifactKind) {
            return {
                role: artifactKind,
                base: file?.artifact_base || withoutExt,
                dir: file?.artifact_dir || dir,
            };
        }
        const rules = [
            { suffix: '_ocr.status.json', role: 'ocr_status' },
            { suffix: '_embedding.status.json', role: 'embedding_status' },
            { suffix: '_vector.status.json', role: 'vector_status' },
            { suffix: '_ocr.json', role: 'ocr' },
            { suffix: '_embedding.json', role: 'embedding' },
            { suffix: '_vector.json', role: 'vector' },
        ];

        for (const rule of rules) {
            if (lower.endsWith(rule.suffix)) {
                return {
                    role: rule.role,
                    base: filename.slice(0, filename.length - rule.suffix.length) || withoutExt,
                    dir,
                };
            }
        }

        if (lower.endsWith('.status.json')) {
            return { role: 'status', base: filename.slice(0, filename.length - '.status.json'.length) || withoutExt, dir };
        }
        if (role.startsWith('source') || role === 'original' || role === 'original_file') {
            return { role: 'source', base: withoutExt, dir };
        }
        if (role === 'metadata' || role === 'meta') {
            return { role: 'metadata', base: withoutExt, dir };
        }
        if (role === 'ocr' || role === 'ocr_page') {
            return { role: 'ocr', base: withoutExt, dir };
        }
        if (role === 'embedding') {
            return { role: 'embedding', base: withoutExt, dir };
        }
        if (role === 'vector' || role === 'vector_index') {
            return { role: 'vector', base: withoutExt, dir };
        }
        if (role.indexOf('status') >= 0) {
            return { role: 'status', base: withoutExt, dir };
        }
        if (ext === 'json') {
            return { role: 'metadata', base: withoutExt, dir };
        }
        if (['pdf', 'hwp', 'hwpx', 'doc', 'docx', 'txt'].includes(ext)) {
            return { role: 'source', base: withoutExt, dir };
        }
        return { role: 'other', base: withoutExt, dir };
    }

    public slotFileLabel(slot: any) {
        if (!slot?.files?.length) return '없음';
        const first = slot.files[0];
        const extra = slot.files.length > 1 ? ` +${slot.files.length - 1}` : '';
        return `${first.name}${extra}`;
    }

    public slotStatusLabel(slot: any) {
        if (!slot?.files?.length) return slot?.key === 'source' ? '원본 자료 없음' : '미연결';
        if (slot.files.some((file: any) => this.fileHasError(file))) return '오류';
        if (slot.key === 'source') {
            if (slot.files.some((file: any) => !file.registered)) return '자료 정보 생성 전';
            return '처리 완료';
        }
        if (slot.key === 'status') return '상태 연결';
        return '연결됨';
    }

    public statusFiles(bundle: any) {
        const files = [
            ...(bundle?.status || []),
            ...(bundle?.ocr_status || []),
            ...(bundle?.embedding_status || []),
            ...(bundle?.vector_status || []),
        ];
        const map: any = {};
        for (const file of files) {
            map[file?.path || file?.name] = file;
        }
        return Object.values(map);
    }

    public statusFileLabel(bundle: any) {
        const count = this.statusFiles(bundle).length;
        return count > 0 ? `${this.number(count)}개` : '미연결';
    }

    public sourceFiles(bundle: any) {
        return bundle?.source || [];
    }

    public sourceModeLabel(value: string) {
        const mode = String(value || '').trim();
        if (mode === 'new_upload') return '신규 업로드';
        if (mode === 'migrated_2025') return '2025 이관';
        return mode || '2025 이관';
    }

    public bundleSourceModeLabel(bundle: any) {
        return bundle?.source_mode_label || this.sourceModeLabel(bundle?.source_mode || '');
    }

    public bundleTypeLabel(bundle: any) {
        const file = this.sourceFiles(bundle)[0] || this.bundlePrimaryFile(bundle);
        const sourceType = String(bundle?.source_type || file?.source_type || '').trim();
        if (sourceType) return this.sourceTypeLabel(sourceType);
        const extension = String(file?.extension || '').trim();
        if (extension) return this.extensionLabel({ extension });
        return '-';
    }

    public sourceTypeLabel(value: string) {
        const text = String(value || '').trim();
        const normalized = text.toLowerCase().replace(/^\./, '');
        const labels: any = {
            pdf: 'PDF',
            hwp: 'HWP',
            hwpx: 'HWPX',
            doc: 'DOC',
            docx: 'DOCX',
            txt: 'TXT',
            json: 'JSON',
        };
        return labels[normalized] || text.toUpperCase();
    }

    public fileStatusValues(file: any) {
        return [
            file?.parse_status,
            file?.artifact_status,
            file?.ocr_status,
            file?.embedding_status,
            file?.vector_status,
            file?.quality_status,
        ].map((status: any) => String(status || '').toLowerCase()).filter((status: string) => status);
    }

    public isErrorStatus(status: string) {
        return ['failed', 'error', 'missing', 'blocked', 'rejected', 'change_requested'].includes(String(status || '').toLowerCase());
    }

    public fileHasError(file: any) {
        return this.fileStatusValues(file).some((status: string) => this.isErrorStatus(status));
    }

    public bundleErrorCount(bundle: any) {
        return (bundle?.files || []).filter((file: any) => this.fileHasError(file)).length;
    }

    public bundleUnregisteredSourceCount(bundle: any) {
        return this.sourceFiles(bundle).filter((file: any) => !file.registered).length;
    }

    public bundlePipelineMetadata(bundle: any) {
        const result: any = {};
        const sources = [
            bundle?.pipeline_status,
            ...(bundle?.files || []).map((file: any) => file?.pipeline_status),
        ];
        for (const source of sources) {
            if (!source || typeof source !== 'object') continue;
            for (const key of Object.keys(source)) {
                const value = String(source[key] || '').trim().toLowerCase();
                if (value && !result[key]) result[key] = value;
            }
        }
        return result;
    }

    public pipelineRawStatus(bundle: any, key: string) {
        const metadata = this.bundlePipelineMetadata(bundle);
        return String(metadata?.[key] || '').toLowerCase();
    }

    public pipelineStatusFromRaw(status: string) {
        const value = String(status || '').toLowerCase();
        if (!value) return '';
        if (this.isErrorStatus(value)) return 'attention';
        if (this.doneStatus(value)) return 'usable';
        if (['pending', 'queued', 'running', 'working', 'processing', 'new', 'discovered', 'unknown', 'unchecked'].includes(value)) return 'processing';
        return '';
    }

    public bundleSourceStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'original_file'));
        if (explicit === 'attention') return 'attention';
        const files = this.sourceFiles(bundle);
        if (!files.length) return explicit || 'unavailable';
        if (files.some((file: any) => this.fileHasError(file))) return 'attention';
        if (explicit === 'usable') return 'usable';
        if (files.some((file: any) => file?.registered || file?.document_id) || this.bundleDocumentId(bundle)) return 'usable';
        return explicit || 'processing';
    }

    public bundleMetadataStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'metadata'));
        if (explicit === 'attention') return 'attention';
        if (this.bundleErrorCount(bundle) > 0) return 'attention';
        if (this.bundleDocumentId(bundle) && Number(bundle?.metadata?.length || 0) > 0) return 'usable';
        const sourceStatus = this.bundleSourceStageStatus(bundle);
        if (sourceStatus === 'attention') return 'attention';
        if (sourceStatus === 'usable') return explicit || 'processing';
        return 'unavailable';
    }

    public bundleOcrStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'ocr_page'));
        const inferred = this.bundleStageStatus(bundle, 'ocr');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleMetadataStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleChunkStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'chunk'));
        const inferred = this.bundleStageStatus(bundle, 'chunk');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleOcrStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleEmbeddingStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'embedding'));
        const status = String(this.bundleProcessStatus(bundle, 'embedding_status') || '').toLowerCase();
        if (explicit === 'attention' || this.bundleStageHasError(bundle, 'embedding', 'embedding_status')) return 'attention';
        if (explicit === 'usable' && Number(bundle?.embedding_chunk_count || 0) > 0) return 'usable';
        if (Number(bundle?.embedding_chunk_count || 0) > 0 && (
            this.doneStatus(status)
            || Number(bundle?.embedding?.length || 0) > 0
            || Number(bundle?.vector_inserted_count || 0) > 0
            || Number(bundle?.eligible_evidence_count || 0) > 0
            || this.doneStatus(this.bundleProcessStatus(bundle, 'vector_status'))
            || this.bundleSourceModeLabel(bundle) !== '신규 업로드'
        )) return 'usable';
        if (explicit === 'processing') return 'processing';
        if (this.bundleChunkStageStatus(bundle) !== 'usable') return 'unavailable';
        if (this.hasWorkingStatus(bundle, 'embedding') || this.waitingStatus(status)) return 'processing';
        return 'attention';
    }

    public bundleVectorStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'vector_index'));
        const inferred = this.bundleStageStatus(bundle, 'vector');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleEmbeddingStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleEvidenceStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'evidence_ready'));
        const inferred = this.bundleStageStatus(bundle, 'evidence');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleVectorStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleOriginalRegisteredStatus(bundle: any) {
        const status = String(bundle?.source_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleSourceStageStatus(bundle);
    }

    public bundleTextReadyStatus(bundle: any) {
        const status = String(bundle?.text_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleOcrStageStatus(bundle);
    }

    public bundleQaEvidenceReadyStatus(bundle: any) {
        const status = String(bundle?.qa_evidence_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleEvidenceStageStatus(bundle);
    }

    public bundleReviewRequiredStatus(bundle: any) {
        const status = String(bundle?.review_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleErrorCount(bundle) > 0 ? 'attention' : 'usable';
    }

    public pipelineStageValue(bundle: any, key: string, status: string) {
        if (key === 'source') return status === 'usable' ? `${this.number(this.sourceFiles(bundle).length)}개` : this.pipelineStageStatusLabel(status);
        if (key === 'text') return Number(bundle?.ocr_page_count || 0) > 0 ? `${this.number(bundle?.ocr_page_count)}쪽` : this.pipelineStageStatusLabel(status);
        if (key === 'qa_evidence') return Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) > 0 ? `${this.number(bundle?.eligible_evidence_count || bundle?.evidence_count)}개` : this.pipelineStageStatusLabel(status);
        if (key === 'review') return status === 'attention' ? '필요' : '없음';
        if (key === 'metadata') return status === 'usable' ? '생성됨' : this.pipelineStageStatusLabel(status);
        if (key === 'ocr') return Number(bundle?.ocr_page_count || 0) > 0 ? `${this.number(bundle?.ocr_page_count)}쪽` : this.pipelineStageStatusLabel(status);
        if (key === 'chunk') return Number(bundle?.embedding_chunk_count || 0) > 0 ? `${this.number(bundle?.embedding_chunk_count)}개` : this.pipelineStageStatusLabel(status);
        if (key === 'embedding') return this.statusLabel(this.bundleProcessStatus(bundle, 'embedding_status') || (status === 'usable' ? 'completed' : status));
        if (key === 'vector') return `${this.number(bundle?.vector_inserted_count)} / ${this.number(bundle?.vector_count || bundle?.embedding_chunk_count)}개`;
        if (key === 'evidence') return Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) > 0 ? `${this.number(bundle?.eligible_evidence_count || bundle?.evidence_count)}개` : this.pipelineStageStatusLabel(status);
        return this.pipelineStageStatusLabel(status);
    }

    public pipelineStageSub(bundle: any, key: string, status: string) {
        if (status === 'attention') return this.bundlePipelineStopReason(bundle, key);
        if (key === 'source') return this.bundleSourceModeLabel(bundle);
        if (key === 'text') return status === 'usable' ? '텍스트 자료 사용 가능' : '텍스트 자료 생성 대기';
        if (key === 'qa_evidence') return status === 'usable' ? '근거 자료 사용 가능' : '텍스트 자료 후 근거 자료 생성';
        if (key === 'review') return status === 'usable' ? '준비 완료' : '점검 확인 필요';
        if (key === 'metadata') return this.bundleDocumentId(bundle) ? `자료 ID ${this.shortId(this.bundleDocumentId(bundle))}` : '자료 정보 생성 대기';
        if (key === 'ocr') return this.statusLabel(this.bundleProcessStatus(bundle, 'ocr_status') || (status === 'usable' ? 'completed' : 'pending'));
        if (key === 'chunk') return this.statusLabel(this.bundleProcessStatus(bundle, 'embedding_status') || (status === 'usable' ? 'completed' : 'pending'));
        if (key === 'embedding') return Number(bundle?.embedding_chunk_count || 0) > 0 ? `근거 자료 ${this.number(bundle?.embedding_chunk_count)}건 기준` : '근거 자료 생성 후 진행';
        if (key === 'vector') return this.statusLabel(this.bundleProcessStatus(bundle, 'vector_status') || (status === 'usable' ? 'indexed' : 'pending'));
        if (key === 'evidence') return status === 'usable' ? '근거 자료 사용 가능' : '근거 색인 후 판정';
        return '';
    }

    public bundlePipelineSteps(bundle: any) {
        const steps = [
            { key: 'source', label: '원본 확보', status: this.bundleOriginalRegisteredStatus(bundle) },
            { key: 'text', label: '텍스트 자료', status: this.bundleTextReadyStatus(bundle) },
            { key: 'qa_evidence', label: '근거 자료', status: this.bundleQaEvidenceReadyStatus(bundle) },
            { key: 'review', label: '준비 점검', status: this.bundleReviewRequiredStatus(bundle) },
        ];
        return steps.map((step: any) => ({
            ...step,
            value: this.pipelineStageValue(bundle, step.key, step.status),
            sub: this.pipelineStageSub(bundle, step.key, step.status),
        }));
    }

    public pipelineStageStatusLabel(status: string) {
        if (status === 'usable') return '완료';
        if (status === 'processing') return '준비 중';
        if (status === 'attention') return '점검 필요';
        return '대기';
    }

    public pipelineStageClass(status: string) {
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        if (status === 'processing') return 'border-amber-200 bg-amber-50 text-amber-800';
        if (status === 'attention') return 'border-rose-200 bg-rose-50 text-rose-800 ring-1 ring-rose-200';
        return 'border-gray-200 bg-gray-50 text-gray-500';
    }

    public pipelineStepDotClass(status: string) {
        if (status === 'usable') return 'bg-emerald-500';
        if (status === 'processing') return 'bg-amber-500';
        if (status === 'attention') return 'bg-rose-500';
        return 'bg-gray-300';
    }

    public bundlePipelineCurrentStep(bundle: any) {
        return this.bundlePipelineSteps(bundle).find((step: any) => step.status !== 'usable') || null;
    }

    public bundlePipelineSummary(bundle: any) {
        const current = this.bundlePipelineCurrentStep(bundle);
        if (!current) return 'QA 작성용 근거 자료 준비 완료';
        if (current.status === 'attention') return this.businessStatusText(`${current.label} · ${current.sub || current.value}`);
        if (current.status === 'processing') return this.businessStatusText(`${current.label} 준비 중 · ${current.sub || current.value}`);
        return this.businessStatusText(`${current.label} 대기 · 이전 단계 완료 필요`);
    }

    public businessStatusText(value: string) {
        const text = String(value || '').trim();
        if (!text) return '';
        return text
            .replace(/chunk\s*[·/]\s*embedding\s*[·/]\s*vector/gi, '근거 자료')
            .replace(/milvus/gi, '근거 자료 저장소')
            .replace(/embedding/gi, '근거 자료')
            .replace(/vector/gi, '근거 색인')
            .replace(/chunk/gi, '텍스트 단위');
    }

    public bundlePipelineStopReason(bundle: any, key: string) {
        if (this.bundleErrorCount(bundle) > 0) return '오류 상태 자료 확인 필요';
        if (key === 'source') return '원본 자료 확인 필요';
        if (key === 'text') return '텍스트 자료 상태 확인 필요';
        if (key === 'qa_evidence') return '근거 자료 상태 확인 필요';
        if (key === 'review') return '준비 점검 필요';
        if (key === 'metadata') return '자료 정보 연결 필요';
        if (key === 'ocr') return '텍스트 자료 필요';
        if (key === 'chunk') return '근거 자료 필요';
        if (key === 'embedding') return '근거 자료 상태 확인 필요';
        if (key === 'vector') return '근거 색인 필요';
        if (key === 'evidence') return '근거 색인 필요';
        return bundle?.qa_reason || '상태 확인 필요';
    }

    public bundleStageStatus(bundle: any, key: string) {
        if (key === 'source') {
            const files = this.sourceFiles(bundle);
            if (!files.length) return 'unavailable';
            if (files.some((file: any) => this.isErrorStatus(file?.parse_status || file?.artifact_status))) return 'attention';
            return 'usable';
        }
        if (key === 'evidence') {
            if (Number(bundle?.eligible_evidence_count || 0) > 0) return 'usable';
            if (Number(bundle?.evidence_count || 0) > 0 && Number(bundle?.vector_inserted_count || 0) > 0) return 'usable';
            if (Number(bundle?.embedding_chunk_count || 0) > 0) return 'processing';
            return this.bundleStageStatus(bundle, 'chunk') === 'processing' ? 'processing' : 'unavailable';
        }

        const artifactKey = key === 'chunk' ? 'embedding' : key;
        const statusKey = artifactKey === 'ocr' ? 'ocr_status' : (artifactKey === 'embedding' ? 'embedding_status' : (artifactKey === 'vector' ? 'vector_status' : ''));
        if (this.bundleStageHasError(bundle, artifactKey, statusKey)) return 'attention';

        const countKey = key === 'ocr' ? 'ocr_page_count' : (key === 'chunk' ? 'embedding_chunk_count' : 'vector_inserted_count');
        if (Number(bundle?.[countKey] || 0) > 0) return 'usable';
        if (this.hasWorkingStatus(bundle, artifactKey)) return 'processing';

        const processStatus = statusKey ? this.bundleProcessStatus(bundle, statusKey) : '';
        if (processStatus && !this.doneStatus(processStatus) && !this.isErrorStatus(processStatus)) return 'processing';
        return 'attention';
    }

    public bundleStageHasError(bundle: any, artifactKey: string, statusKey: string = '') {
        const files = [
            ...(bundle?.[artifactKey] || []),
            ...(statusKey ? (bundle?.[statusKey] || []) : []),
        ];
        if (files.some((file: any) => this.fileHasError(file))) return true;
        return statusKey ? this.isErrorStatus(this.bundleProcessStatus(bundle, statusKey)) : false;
    }

    public bundleStageLabel(bundle: any, key: string) {
        const status = this.bundleStageStatus(bundle, key);
        if (key === 'source') {
            if (status === 'attention') return Number(this.sourceFiles(bundle).length || 0) > 0 ? '확인 필요' : '없음';
            return '있음';
        }
        if (key === 'ocr') {
            const count = Number(bundle?.ocr_page_count || 0);
            if (count > 0) return `${this.number(count)}p`;
        }
        if (key === 'chunk') {
            const count = Number(bundle?.embedding_chunk_count || 0);
            if (count > 0) return `${this.number(count)}개`;
        }
        if (key === 'vector') {
            const count = Number(bundle?.vector_inserted_count || 0);
            if (count > 0) return `${this.number(count)}개`;
        }
        if (key === 'evidence') {
            const count = Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0);
            if (count > 0) return `${this.number(count)}개`;
        }
        if (status === 'processing') return '처리 중';
        if (status === 'unavailable') return '생성 불가';
        if (status === 'attention') return this.bundleStageHasAnyFile(bundle, key) ? '확인 필요' : '없음';
        return '있음';
    }

    public bundleStageHasAnyFile(bundle: any, key: string) {
        if (key === 'source') return Number(this.sourceFiles(bundle).length || 0) > 0;
        if (key === 'evidence') return Number(bundle?.evidence_count || bundle?.eligible_evidence_count || 0) > 0;
        const artifactKey = key === 'chunk' ? 'embedding' : key;
        const statusKey = artifactKey === 'ocr' ? 'ocr_status' : (artifactKey === 'embedding' ? 'embedding_status' : (artifactKey === 'vector' ? 'vector_status' : ''));
        return Number(bundle?.[artifactKey]?.length || 0) > 0 || Number(bundle?.[statusKey]?.length || 0) > 0;
    }

    public bundleStageClass(bundle: any, key: string) {
        return this.readinessStepClass(this.bundleStageStatus(bundle, key));
    }

    public bundleStatusLabel(bundle: any) {
        if (this.bundleErrorCount(bundle) > 0) return '오류';
        if (bundle?.missing > 0) return '원본 자료 없음';
        if (this.bundleUnregisteredSourceCount(bundle) > 0) return '자료 정보 생성 전';
        return '처리 완료';
    }

    public bundleStatusTone(bundle: any) {
        if (this.bundleErrorCount(bundle) > 0 || bundle?.missing > 0) return 'border-rose-200 bg-rose-50 text-rose-700';
        if (this.bundleUnregisteredSourceCount(bundle) > 0) return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-emerald-200 bg-emerald-50 text-emerald-700';
    }

    public fileTypeCount(key: string) {
        const files = this.filesMatchingQuery();
        if (key === 'all') return files.length;
        return files.filter((file: any) => this.matchesFileType(file, key)).length;
    }

    public matchesFileType(file: any, key: string) {
        const role = this.classifyFile(file).role;
        if (key === 'source') return role === 'source';
        if (key === 'metadata') return role === 'metadata';
        if (key === 'ocr') return role === 'ocr';
        if (key === 'embedding') return role === 'embedding';
        if (key === 'vector') return role === 'vector';
        if (key === 'status') return ['status', 'ocr_status', 'embedding_status', 'vector_status'].includes(role);
        if (key === 'unregistered') return role === 'source' && !file?.registered;
        if (key === 'error') return this.fileHasError(file);
        return true;
    }

    public async setFileTypeFilter(key: string) {
        this.fileTypeFilter = key || 'all';
        this.resetDriveItemWindow();
        await this.service.render();
    }

    public filterClass(key: string) {
        if (this.fileTypeFilter === key) return 'border-gray-950 bg-gray-950 text-white';
        return 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50';
    }

    public bundleProcessStatus(bundle: any, key: string) {
        const source = this.sourceFiles(bundle).find((file: any) => file?.[key]);
        return source?.[key] || '';
    }

    public processStatusLabel(bundle: any, key: string) {
        const status = this.bundleProcessStatus(bundle, key);
        return status ? this.statusLabel(status) : '대기';
    }

    public processStatusTone(bundle: any, key: string) {
        const status = this.bundleProcessStatus(bundle, key);
        return this.statusClass(status || 'pending');
    }

    public firstFileStatus(slot: any) {
        const first = slot.files[0];
        return this.statusLabel(first.parse_status || 'ready');
    }

    public bundleFileCount(bundle: any) {
        return Number(bundle?.files?.length || 0);
    }

    public bundleSize(bundle: any) {
        return (bundle?.files || []).reduce((total: number, file: any) => total + Number(file?.size_bytes || 0), 0);
    }

    public bundleModifiedAt(bundle: any) {
        const files = bundle?.files || [];
        const values = files.map((file: any) => file?.modified_at || '').filter((value: string) => value);
        if (!values.length) return '-';
        return values.sort().reverse()[0];
    }

    public bundlePrimaryFile(bundle: any) {
        const groups = [bundle?.source, bundle?.metadata, bundle?.ocr, bundle?.embedding, bundle?.vector, bundle?.other, bundle?.vector_status, bundle?.ocr_status, bundle?.embedding_status];
        for (const group of groups) {
            if (group?.length) return group[0];
        }
        return null;
    }

    public derivedFileCount(bundle: any) {
        return Math.max(0, this.bundleFileCount(bundle) - Number(bundle?.source?.length || 0));
    }

    public sourceLabel(bundle: any) {
        return Number(bundle?.source?.length || 0) > 0 ? '보존' : '없음';
    }

    public sourceTone(bundle: any) {
        if (Number(bundle?.source?.length || 0) > 0) return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        return 'border-rose-200 bg-rose-50 text-rose-700';
    }

    public registrationLabel(bundle: any) {
        const files = this.sourceFiles(bundle).length ? this.sourceFiles(bundle) : (bundle?.files || []);
        if (!files.length) return '-';
        if (files.some((file: any) => this.fileHasError(file))) return '오류';
        const registered = files.filter((file: any) => file.registered).length;
        if (registered === files.length) return '처리 완료';
        if (registered > 0) return '일부 완료';
        return '자료 정보 생성 전';
    }

    public registrationTone(bundle: any) {
        const files = this.sourceFiles(bundle).length ? this.sourceFiles(bundle) : (bundle?.files || []);
        if (!files.length) return 'border-gray-200 bg-gray-50 text-gray-500';
        if (files.some((file: any) => this.fileHasError(file))) return 'border-rose-200 bg-rose-50 text-rose-700';
        const registered = files.filter((file: any) => file.registered).length;
        if (registered === files.length) return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (registered > 0) return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-gray-200 bg-gray-50 text-gray-500';
    }

    public supportLabel(bundle: any) {
        const count = this.derivedFileCount(bundle);
        return count > 0 ? `${this.number(count)}개` : '없음';
    }

    public supportTone(bundle: any) {
        if (this.derivedFileCount(bundle) > 0) return 'border-sky-200 bg-sky-50 text-sky-700';
        return 'border-gray-200 bg-gray-50 text-gray-500';
    }

    public doneStatus(status: string) {
        return ['completed', 'indexed', 'imported', 'ready', 'passed', 'published', 'approved', 'done'].includes(String(status || '').toLowerCase());
    }

    public waitingStatus(status: string) {
        return ['pending', 'queued', 'running', 'working', 'unknown', 'unchecked', 'new', 'discovered', ''].includes(String(status || '').toLowerCase());
    }

    public artifactStatus(bundle: any, key: string) {
        const files = bundle?.[key] || [];
        if (files.some((file: any) => this.fileHasError(file))) return 'failed';
        if (files.length > 0) return 'completed';
        const statusKey = key === 'ocr' ? 'ocr_status' : (key === 'embedding' ? 'embedding_status' : (key === 'vector' ? 'vector_status' : ''));
        const status = statusKey ? this.bundleProcessStatus(bundle, statusKey) : '';
        if (this.isErrorStatus(status)) return 'failed';
        if (this.doneStatus(status)) return 'completed';
        return 'pending';
    }

    public artifactLabel(bundle: any, key: string) {
        const status = this.artifactStatus(bundle, key);
        if (status === 'failed') return '확인 필요';
        if (status === 'completed') return '있음';
        return '없음';
    }

    public artifactTone(bundle: any, key: string) {
        return this.statusClass(this.artifactStatus(bundle, key));
    }

    public qualityStatus(status: string) {
        const value = String(status || '').toLowerCase();
        if (this.isErrorStatus(value) || ['rejected', 'change_requested'].includes(value)) return 'attention';
        if (this.doneStatus(value)) return 'completed';
        return 'pending';
    }

    public bundleQualityStatus(bundle: any) {
        const files = this.sourceFiles(bundle).length ? this.sourceFiles(bundle) : (bundle?.files || []);
        if (!files.length) return 'attention';
        if (files.some((file: any) => this.qualityStatus(file?.quality_status || '') === 'attention')) return 'attention';
        if (files.some((file: any) => this.qualityStatus(file?.quality_status || '') === 'pending')) return 'pending';
        return 'completed';
    }

    public bundleQualityLabel(bundle: any) {
        const status = this.bundleQualityStatus(bundle);
        if (status === 'attention') return '확인 필요';
        if (status === 'completed') return '확인 완료';
        return '대기';
    }

    public bundleQualityTone(bundle: any) {
        return this.statusClass(this.bundleQualityStatus(bundle));
    }

    public qaStatusLabel(status: string) {
        switch (String(status || '')) {
            case 'usable':
                return '사용 가능';
            case 'partial':
                return '부분 준비';
            case 'processing':
                return '처리 중';
            case 'attention':
                return '확인 필요';
            case 'unavailable':
                return '생성 불가';
            default:
                return this.statusLabel(status || 'attention');
        }
    }

    public qaStatusClass(status: string) {
        switch (String(status || '')) {
            case 'usable':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'partial':
                return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'processing':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'unavailable':
                return 'border-gray-200 bg-gray-50 text-gray-600';
            case 'attention':
                return 'border-rose-200 bg-rose-50 text-rose-700';
            default:
                return this.statusClass(status || 'attention');
        }
    }

    public collectionQaStatus(collection: any) {
        return collection?.qa_status || 'attention';
    }

    public collectionQaMeta(collection: any) {
        return `준비 ${this.number(this.collectionEvidenceReadyDocumentCount(collection))} · 처리중 ${this.number(collection?.qa_processing_count)} · 점검 ${this.number(this.collectionReviewRequiredCount(collection))}`;
    }

    public readinessProgressLabel() {
        const total = Number(this.readiness?.total || this.readinessSummary.document_total || 0);
        const listed = Number(this.readiness?.listed || (this.readiness?.documents || []).length || 0);
        if (!total) return '자료 없음';
        return this.readiness?.truncated ? `${this.number(listed)} / ${this.number(total)}건 표시` : `${this.number(total)}건`;
    }

    public readinessMetricLabel(row: any, key: string) {
        if (key === 'ocr') return `${this.number(row?.ocr_page_count)}쪽`;
        if (key === 'chunk') return `${this.number(row?.actual_chunk_count || row?.chunk_count)}개`;
        if (key === 'vector') {
            const total = Number(row?.vector_count || row?.actual_chunk_count || row?.chunk_count || 0);
            return `${this.number(row?.indexed_vector_count)} / ${this.number(total)}개`;
        }
        if (key === 'evidence') return `${this.number(row?.eligible_evidence_count || row?.evidence_count)}개`;
        return '-';
    }

    public readinessMetricStatus(row: any, key: string) {
        if (key === 'ocr') return row?.ocr_state || 'processing';
        if (key === 'chunk') return row?.chunk_state || 'processing';
        if (key === 'vector') return row?.vector_state || 'processing';
        if (key === 'evidence') return row?.evidence_state || 'processing';
        return 'processing';
    }

    public readinessMetricClass(row: any, key: string) {
        return this.qaStatusClass(this.readinessMetricStatus(row, key));
    }

    public documentQualityLabel(row: any) {
        const status = row?.quality_status || 'unchecked';
        if (row?.quality_state === 'usable') return this.statusLabel(status);
        return '확인 필요';
    }

    public documentPathLabel(row: any) {
        return row?.relative_dir || row?.document_key || row?.id || '-';
    }

    public matches(item: any, text: string, keys: string[]) {
        return keys.some((key: string) => String(item?.[key] || '').toLowerCase().indexOf(text) >= 0);
    }

    public async openCollectionForm() {
        this.collectionActionMenuId = '';
        this.editingCollection = null;
        this.collectionForm = { title: '', description: '' };
        this.showCollectionForm = true;
        this.error = '';
        await this.service.render();
    }

    public async openCollectionEditForm(collection: any) {
        if (!collection?.id) return;
        if (this.collectionDeletionRequested(collection)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 요청 취소 후 수정하세요.');
            return;
        }
        this.collectionActionMenuId = '';
        this.editingCollection = collection;
        this.collectionForm = {
            title: collection.title || '',
            description: collection.description || '',
        };
        this.showCollectionForm = true;
        this.error = '';
        await this.service.render();
    }

    public async closeCollectionForm() {
        if (this.collectionSaving) return;
        this.showCollectionForm = false;
        this.editingCollection = null;
        await this.service.render();
    }

    public collectionFormTitle() {
        return this.editingCollection?.id ? '컬렉션 수정' : '새 컬렉션';
    }

    public collectionFormActionLabel() {
        if (this.collectionSaving) return this.editingCollection?.id ? '저장 중' : '생성 중';
        return this.editingCollection?.id ? '저장' : '생성';
    }

    public async saveCollectionForm() {
        if (this.editingCollection?.id) {
            await this.updateCollection();
            return;
        }
        await this.createCollection();
    }

    public async createCollection() {
        const title = String(this.collectionForm.title || '').trim();
        const description = String(this.collectionForm.description || '').trim();
        if (!title || this.collectionSaving) return;
        this.collectionSaving = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create_collection", { title, description });
            if (code === 200) {
                this.assignDrive(data || {});
                const created = data?.created_collection || data?.current || null;
                if (created?.id) {
                    const url = this.driveUrl(created.id, '');
                    if (`${location.pathname}${location.search}` !== url) {
                        window.history.pushState({}, '', url);
                    }
                    const wizRoute = (window as any).WizRoute;
                    if (wizRoute?.segment) {
                        wizRoute.segment.collection_id = created.id;
                        wizRoute.segment.drive_path = '';
                    }
                }
                this.collectionForm = { title: '', description: '' };
                this.editingCollection = null;
                this.showCollectionForm = false;
                this.uploadMessage = '새 컬렉션을 만들었습니다.';
            } else {
                this.error = data?.message || '컬렉션을 만들지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '컬렉션을 만들지 못했습니다.';
        } finally {
            this.collectionSaving = false;
            await this.service.render();
        }
    }

    public async updateCollection() {
        const collectionId = this.editingCollection?.id || '';
        const title = String(this.collectionForm.title || '').trim();
        const description = String(this.collectionForm.description || '').trim();
        if (!collectionId || !title || this.collectionSaving) return;
        this.collectionSaving = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("update_collection", {
                collection_id: collectionId,
                title,
                description,
            });
            if (code === 200) {
                this.collections = data?.collections || this.collections || [];
                if (data?.updated_collection?.id && this.current?.id === data.updated_collection.id) {
                    this.current = data.updated_collection;
                }
                this.collectionForm = { title: '', description: '' };
                this.editingCollection = null;
                this.showCollectionForm = false;
                this.uploadMessage = data?.message || '컬렉션 정보를 저장했습니다.';
            } else {
                this.error = data?.message || '컬렉션 정보를 저장하지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '컬렉션 정보를 저장하지 못했습니다.';
        } finally {
            this.collectionSaving = false;
            await this.service.render();
        }
    }

    public async selectCollection(collection: any) {
        if (!collection?.id) return;
        this.selected = null;
        this.fileQuery = '';
        this.collectionActionMenuId = '';
        this.expandedCollectionId = '';
        await this.openDriveRoute(collection.id, '');
    }

    public async reindexCollection(collection: any) {
        if (!collection?.id || this.collectionReindexingId) return;
        this.collectionActionMenuId = '';
        this.collectionReindexingId = collection.id;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("reindex_collection", { collection_id: collection.id });
            if (code === 200) {
                this.collections = data?.collections || this.collections || [];
                if (this.current?.id === collection.id) {
                    this.current = data?.updated_collection || this.current;
                }
                const count = Number(data?.reindex?.bundle_count || 0);
                this.uploadMessage = data?.message || `자료 묶음 ${this.number(count)}건을 재색인했습니다.`;
            } else {
                await this.service.modal.error(data?.message || '자료 묶음 재색인에 실패했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '자료 묶음 재색인에 실패했습니다.');
        } finally {
            this.collectionReindexingId = '';
            await this.service.render();
        }
    }

    public async deleteCollection(collection: any) {
        if (!collection?.id || this.collectionDeleting) return;
        this.collectionActionMenuId = '';
        if (this.uploading || this.driveLoading) {
            await this.service.modal.error('업로드 또는 목록 갱신이 끝난 뒤 삭제하세요.');
            return;
        }

        const title = collection.title || collection.id;
        const requested = this.collectionDeletionRequested(collection);
        const immediateDelete = this.collectionImmediateDeleteAvailable(collection);
        const action = this.collectionDeleteActionLabel(collection);
        const message = requested
            ? `${title} 컬렉션의 폐기 요청을 취소하고 다시 사용할 수 있게 전환합니다.`
            : immediateDelete
                ? `${title} 빈 컬렉션을 즉시 삭제하시겠습니까? 생성된 빈 폴더와 목록 항목이 제거됩니다.`
                : `${title} 컬렉션을 폐기 요청 상태로 전환하시겠습니까? 자료와 QA 데이터는 보존되고 변경 작업은 중지됩니다.`;
        const confirmed = await this.service.modal.show({
            title: requested ? '폐기 요청 취소' : immediateDelete ? '컬렉션 삭제' : '컬렉션 폐기 요청',
            message,
            action,
            cancel: '취소',
            status: requested ? 'warning' : immediateDelete ? 'error' : 'warning',
            actionBtn: immediateDelete ? 'error' : 'warning',
        });
        if (!confirmed) return;

        this.collectionDeleting = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const apiName = requested ? "cancel_collection_deletion" : immediateDelete ? "delete_collection" : "request_collection_deletion";
            const { code, data } = await wiz.call(apiName, { collection_id: collection.id });
            if (code === 200) {
                if (immediateDelete) {
                    this.selected = null;
                    this.fileQuery = '';
                    this.driveActionMenuOpen = false;
                    this.showNewFolderForm = false;
                    const url = '/literature';
                    if (`${location.pathname}${location.search}` !== url) {
                        window.history.pushState({}, '', url);
                    }
                    const wizRoute = (window as any).WizRoute;
                    if (wizRoute?.segment) {
                        wizRoute.segment.collection_id = '';
                        wizRoute.segment.drive_path = '';
                    }
                    this.assignDrive(data || {});
                } else {
                    this.collections = data?.collections || this.collections || [];
                    if (data?.updated_collection?.id && this.current?.id === data.updated_collection.id) {
                        this.current = data.updated_collection;
                    }
                }
                this.uploadMessage = data?.message || (requested ? '폐기 요청을 취소했습니다.' : immediateDelete ? '컬렉션을 삭제했습니다.' : '컬렉션 폐기 요청을 등록했습니다.');
            } else {
                await this.service.modal.error(data?.message || '컬렉션 상태를 변경하지 못했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '컬렉션 상태를 변경하지 못했습니다.');
        } finally {
            this.collectionDeleting = false;
            await this.service.render();
        }
    }

    public async openCollectionQa(collection: any) {
        if (!collection?.id) return;
        if (this.collectionDeletionRequested(collection)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 QA 작성에 사용할 수 없습니다.');
            return;
        }
        if (!this.collectionReadyForQaAuthoring(collection)) {
            await this.service.modal.error('원본 자료, 텍스트 자료, 근거 자료와 준비 점검가 모두 통과한 컬렉션만 QA 작성으로 이동할 수 있습니다.');
            return;
        }
        this.selected = null;
        this.selectedCollectionId = collection.id;
        this.datasetCollection = collection;
        this.datasetForm = { ...this.datasetForm, collection_id: collection.id };
        this.qaForm = { ...this.emptyQaForm(), collection_id: collection.id };
        this.candidateResult = null;
        this.task = 'dataset';
        const url = `/qa?collection_id=${encodeURIComponent(collection.id)}`;
        if (`${location.pathname}${location.search}` !== url) {
            window.history.pushState({}, '', url);
        }
        this.loading = true;
        await this.loadDatasetAuthoring();
    }

    public async openFolder(folder: any) {
        if (!folder?.id) return;
        this.selected = null;
        this.fileQuery = '';
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.openDriveRoute(this.current?.id || '', folder.id);
    }

    public async openBreadcrumb(crumb: any) {
        this.fileQuery = '';
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.openDriveRoute(this.current?.id || '', crumb?.id || '');
    }

    public async loadArtifactChain(showError: boolean = true) {
        const documentId = this.selected?.document_id || '';
        if (!documentId) return;
        const targetId = documentId;
        try {
            const { code, data } = await wiz.call("artifact_chain", { document_id: targetId });
            if (this.selected?.document_id !== targetId) return;
            if (code === 200) {
                this.selected = { ...this.selected, artifact_chain: data?.chain || null };
            } else if (showError) {
                this.error = data?.message || '자료 처리 결과를 불러오지 못했습니다.';
            }
        } catch (error: any) {
            if (showError) this.error = error?.message || '자료 처리 결과를 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async buildArtifactChain() {
        const documentId = this.selected?.document_id || '';
        if (!documentId || this.artifactBuilding) return;
        this.artifactBuilding = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("build_artifact_chain", { document_id: documentId });
            if (code === 200) {
                this.selected = { ...this.selected, artifact_chain: data?.chain || null };
                const status = data?.chain?.run?.status || '';
                this.uploadMessage = status === 'passed' ? '자료 처리 결과를 생성했습니다.' : '자료 처리 결과에 확인 필요 항목이 있습니다.';
            } else {
                this.error = data?.message || '자료 처리 결과를 생성하지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '자료 처리 결과를 생성하지 못했습니다.';
        } finally {
            this.artifactBuilding = false;
            await this.service.render();
        }
    }

    public async loadDatasetArtifact(showError: boolean = true) {
        const documentId = this.selected?.document_id || '';
        if (!documentId) return;
        const targetId = documentId;
        try {
            const { code, data } = await wiz.call("dataset_artifact", { document_id: targetId });
            if (this.selected?.document_id !== targetId) return;
            if (code === 200) {
                this.selected = { ...this.selected, dataset_artifact: data?.artifact || null };
            } else if (showError) {
                this.error = data?.message || 'QA 후보 결과를 불러오지 못했습니다.';
            }
        } catch (error: any) {
            if (showError) this.error = error?.message || 'QA 후보 결과를 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async buildDatasetArtifact() {
        const documentId = this.selected?.document_id || '';
        if (!documentId || this.datasetBuilding) return;
        this.datasetBuilding = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const params: any = { document_id: documentId };
            const h2RunId = this.selected?.artifact_chain?.run?.id || '';
            if (h2RunId) params.h2_run_id = h2RunId;
            const { code, data } = await wiz.call("build_dataset_artifact", params);
            if (code === 200) {
                this.selected = { ...this.selected, dataset_artifact: data?.artifact || null };
                const status = data?.artifact?.run?.status || '';
                this.uploadMessage = status === 'passed' ? 'QA 후보를 생성했습니다.' : 'QA 후보 생성 결과에 확인 필요 항목이 있습니다.';
                await this.loadArtifactChain(false);
            } else {
                this.error = data?.message || 'QA 후보를 생성하지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || 'QA 후보를 생성하지 못했습니다.';
        } finally {
            this.datasetBuilding = false;
            await this.service.render();
        }
    }

    public selectedChain() {
        return this.selected?.artifact_chain || null;
    }

    public chainArtifacts() {
        return this.selected?.artifact_chain?.artifacts || [];
    }

    public chainGates() {
        return this.selected?.artifact_chain?.gates || [];
    }

    public selectedDatasetArtifact() {
        return this.selected?.dataset_artifact || null;
    }

    public datasetArtifacts() {
        return this.selected?.dataset_artifact?.artifacts || [];
    }

    public datasetGates() {
        return this.selected?.dataset_artifact?.gates || [];
    }

    public datasetOutput() {
        return this.selected?.dataset_artifact?.output || {};
    }

    public datasetCandidateMeta() {
        const artifact = this.datasetArtifacts().find((item: any) => item.artifact_type === 'dataset_candidate');
        return artifact?.metadata || {};
    }

    public artifactTypeLabel(type: string) {
        switch (type) {
            case 'original_file':
                return '원본 자료';
            case 'ocr_page':
                return '텍스트 자료';
            case 'chunk':
                return '근거 자료';
            case 'vector_index':
                return '근거 색인';
            default:
                return type || '-';
        }
    }

    public datasetArtifactTypeLabel(type: string) {
        switch (type) {
            case 'evidence_bundle':
                return '근거 자료';
            case 'dataset_candidate':
                return 'QA 후보';
            default:
                return type || '-';
        }
    }

    public shortId(value: string) {
        return value ? String(value).slice(0, 8) : '-';
    }

    public emptyQaForm() {
        return {
            id: '',
            dataset_id: '',
            collection_id: '',
            item_type: 'qa',
            difficulty: 'medium',
            split: 'train',
            status: 'draft',
            domain: '',
            question: '',
            answer: '',
            instruction: '선택한 근거만 사용해 답변하세요.',
            reason: '',
            source_document_id: '',
            source_chunk_id: '',
            evidence_ids: [],
            input_text: '',
        };
    }

    public selectedDataset() {
        return this.qaDatasets.find((dataset: any) => dataset.id === this.selectedDatasetId) || null;
    }

    public selectedDatasetCollection() {
        return this.collections.find((collection: any) => collection.id === this.selectedCollectionId)
            || this.datasetCollection
            || null;
    }

    public datasetScopeSummary() {
        return this.datasetSummary?.collection_scope || {};
    }

    public scopeReadyDocuments() {
        return this.datasetScopeSummary()?.evidence_ready_documents || [];
    }

    public scopeExcludedDocuments() {
        return this.datasetScopeSummary()?.excluded_documents || [];
    }

    public collectionHasEvidenceReady() {
        const selected = this.selectedDatasetCollection();
        if (this.collectionDeletionRequested(selected)) return false;
        const scope = this.datasetScopeSummary();
        return Number(scope?.evidence_ready_chunk_count || scope?.h2_chunk_count || 0) > 0
            && Number(scope?.evidence_ready_document_count || scope?.h2_document_count || 0) > 0;
    }

    public datasetScopeLabel() {
        const scope = this.datasetScopeSummary();
        const total = scope?.document_total || scope?.source_document_count || 0;
        const ready = scope?.evidence_ready_document_count || scope?.h2_document_count || 0;
        const excluded = scope?.excluded_document_count || Math.max(0, Number(total || 0) - Number(ready || 0));
        const migrated = Number(scope?.migrated_2025_count || 0);
        const uploaded = Number(scope?.new_upload_count || 0);
        const source = uploaded > 0 || migrated > 0
            ? `2025 이관 ${this.number(migrated)} · 신규 ${this.number(uploaded)}`
            : '';
        return `전체 ${this.number(total)}건 · 준비 완료 ${this.number(ready)}건 · 제외 ${this.number(excluded)}건${source ? ' · ' + source : ''}`;
    }

    public h3Summary() {
        return this.datasetSummary?.h3 || {};
    }

    public h3ArtifactHistory() {
        return this.h3Summary()?.artifacts || [];
    }

    public latestH3Artifact() {
        return this.h3Summary()?.latest_artifact || {};
    }

    public h3GateStatus() {
        return this.h3Summary()?.gate_status || 'not_created';
    }

    public h3GateStatusLabel() {
        const status = this.h3GateStatus();
        if (status === 'not_created') return '생성 전';
        return this.statusLabel(status);
    }

    public h3GateStatusClass() {
        return this.statusClass(this.h3GateStatus());
    }

    public reviewRequestable() {
        return this.h3Summary()?.review_requestable === true;
    }

    public reviewRequestReason() {
        return this.h3Summary()?.review_request_reason || '검수 요청 가능 상태를 확인하세요.';
    }

    public compactDateTime(value: any) {
        const text = String(value || '').replace('T', ' ').trim();
        return text ? text.slice(0, 16) : '-';
    }

    public h3GateMessage() {
        const message = String(this.h3Summary()?.gate_message || '').trim();
        if (message) return this.businessStatusText(message);
        if (this.h3GateStatus() === 'passed') return '준비 완료';
        if (this.h3GateStatus() === 'not_created') return 'QA 후보 생성 필요';
        return '점검 확인 필요';
    }

    public h3ArtifactLabel(item: any) {
        if (!item?.candidate_artifact_id) return `${this.compactDateTime(item?.created)} 작성용 초안`;
        return `${this.compactDateTime(item?.finished_at || item?.created)} 생성 결과`;
    }

    public h3ArtifactSubLabel(item: any) {
        const candidate = this.number(item?.candidate_count || 0);
        const created = this.number(item?.created_count || 0);
        const duplicate = this.number(item?.duplicate_count || 0);
        const evidence = this.number(item?.evidence_count || 0);
        return `후보 ${candidate}건 · 신규 ${created}건 · 중복 ${duplicate}건 · 근거 ${evidence}건`;
    }

    public h3StatusCards() {
        const latest = this.latestH3Artifact();
        const generated = !!latest?.candidate_artifact_id;
        const h3Status = this.h3GateStatus();
        return [
            {
                label: '생성 결과',
                value: generated ? `${this.number(latest.candidate_count || 0)}건` : '생성 전',
                sub: generated ? this.h3ArtifactSubLabel(latest) : 'QA 후보 생성 후 결과 표시',
                status: generated ? (h3Status === 'passed' ? 'usable' : h3Status) : 'not_created',
            },
            {
                label: '자동 점검',
                value: this.h3GateStatusLabel(),
                sub: this.h3GateMessage(),
                status: h3Status,
            },
            {
                label: '검수 전환',
                value: this.reviewRequestable() ? '가능' : '대기',
                sub: `검수 가능 ${this.number(this.reviewableCount())}건 · ${this.reviewRequestReason()}`,
                status: this.reviewRequestable() ? 'gate_ready' : (this.reviewFlowCount() > 0 ? 'processing' : 'unavailable'),
            },
        ];
    }

    public h3GateChecklist() {
        const gates = this.latestH3Artifact()?.gates || [];
        if (gates.length > 0) {
            return gates
                .filter((gate: any) => ['candidate.schema.valid', 'candidate.grounded', 'citation.match', 'dataset.duplicate.check', 'dataset.g3.ready'].includes(gate.gate_id))
                .map((gate: any) => ({
                    label: gate.label || gate.gate_id,
                    status: gate.status || 'pending',
                    message: this.businessStatusText(gate.message || ''),
                }));
        }
        return [
            { label: 'QA 형식', status: 'not_created', message: '생성 결과 없음' },
            { label: '근거 연결', status: 'not_created', message: '생성 결과 없음' },
            { label: '답변-근거 일치', status: 'not_created', message: '생성 결과 없음' },
            { label: '중복 확인', status: 'not_created', message: '생성 결과 없음' },
            { label: 'QA 품질 점검', status: 'not_created', message: '생성 결과 없음' },
        ];
    }

    public h3FlowItems() {
        const collectionSelected = !!this.selectedCollectionId && !!this.selectedDatasetCollection();
        const hasEvidence = this.collectionHasEvidenceReady();
        const hasDataset = !!this.selectedDatasetId;
        const hasHistory = this.h3ArtifactHistory().length > 0;
        const h3Status = this.h3GateStatus();
        const hasItems = this.qaItems.length > 0;
        const reviewable = this.reviewRequestable();
        return [
            {
                label: '컬렉션 선택',
                value: collectionSelected ? (this.selectedDatasetCollection()?.title || this.selectedCollectionId) : '필요',
                status: collectionSelected && hasEvidence ? 'usable' : 'processing',
            },
            {
                label: '근거 검색',
                value: hasEvidence ? `${this.number(this.evidenceChunks.length)}건` : '대기',
                status: hasEvidence ? 'usable' : 'processing',
            },
            {
                label: 'QA 후보',
                value: hasDataset ? (this.selectedDataset()?.name || '선택됨') : '필요',
                status: h3Status === 'passed' ? 'usable' : (hasHistory ? h3Status : 'processing'),
            },
            {
                label: 'QA 편집',
                value: hasItems ? `${this.number(this.qaItems.length)}건` : '대기',
                status: hasItems ? 'usable' : (hasDataset ? 'processing' : 'unavailable'),
            },
            {
                label: '검수 요청',
                value: reviewable ? `${this.number(this.reviewableCount())}건 가능` : this.reviewRequestReason(),
                status: reviewable ? 'usable' : (this.reviewFlowCount() > 0 ? 'processing' : 'unavailable'),
            },
        ];
    }

    public candidateResultLabel() {
        if (!this.candidateResult) return '';
        return `생성 ${this.number(this.candidateResult.created_count)}건 · 중복 ${this.number(this.candidateResult.duplicate_count)}건 · 근거 ${this.number(this.candidateResult.evidence_count)}건`;
    }

    public async openDatasetForm() {
        if (!this.selectedCollectionId) {
            await this.service.modal.error('QA 후보를 만들 컬렉션을 먼저 선택하세요.');
            return;
        }
        const selected = this.selectedDatasetCollection();
        if (this.collectionDeletionRequested(selected)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 QA 후보를 만들 수 없습니다.');
            return;
        }
        if (selected && !this.collectionQaAvailable(selected)) {
            await this.service.modal.error('준비 완료된 근거 자료가 있는 컬렉션만 QA 후보를 만들 수 있습니다.');
            return;
        }
        this.datasetForm = {
            ...this.datasetForm,
            collection_id: this.selectedCollectionId,
        };
        this.showDatasetForm = true;
        await this.service.render();
    }

    public async selectDatasetCollection(collection: any) {
        const collectionId = typeof collection === 'string' ? collection : (collection?.id || '');
        if (!collectionId) {
            this.selectedCollectionId = '';
            this.datasetCollection = null;
            this.selectedDatasetId = '';
            this.selectedQaItemId = '';
            this.selectedChunk = null;
            this.candidateResult = null;
            this.qaForm = this.emptyQaForm();
            this.datasetForm = { ...this.datasetForm, collection_id: '' };
            await this.loadDatasetAuthoring();
            return;
        }
        const selected = this.collections.find((row: any) => row.id === collectionId);
        if (selected && !this.collectionQaAvailable(selected)) {
            await this.service.modal.error('준비 완료된 근거 자료가 있는 컬렉션만 선택할 수 있습니다.');
            this.selectedCollectionId = '';
            this.datasetForm = { ...this.datasetForm, collection_id: '' };
            await this.service.render();
            return;
        }
        if (collectionId === this.selectedCollectionId && this.datasetCollection) return;
        this.selectedCollectionId = collectionId;
        this.selectedDatasetId = '';
        this.selectedQaItemId = '';
        this.selectedChunk = null;
        this.candidateResult = null;
        this.qaForm = { ...this.emptyQaForm(), collection_id: collectionId };
        this.datasetForm = { ...this.datasetForm, collection_id: collectionId };
        await this.loadDatasetAuthoring();
    }

    public selectedQaItem() {
        return this.qaItems.find((item: any) => item.id === this.selectedQaItemId) || null;
    }

    public async loadDatasetAuthoring() {
        if (!this.selectedCollectionId) {
            const params = new URLSearchParams(location.search || '');
            const collectionId = this.qaRouteCollectionId();
            if (collectionId) {
                this.selectedCollectionId = collectionId;
                this.datasetForm = { ...this.datasetForm, collection_id: collectionId };
                this.qaForm = { ...this.qaForm, collection_id: collectionId };
            }
        }
        this.datasetError = '';
        this.datasetLoading = !this.loading;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("dataset_authoring", {
                dataset_id: this.selectedDatasetId || '',
                collection_id: this.selectedCollectionId || '',
                q: this.qaQuery || '',
                evidence_q: this.evidenceQuery || '',
                status: this.itemStatusFilter === 'all' ? '' : this.itemStatusFilter,
                split: this.splitFilter === 'all' ? '' : this.splitFilter,
                difficulty: this.difficultyFilter === 'all' ? '' : this.difficultyFilter,
            });
            if (code === 200) {
                this.collections = data?.collections || this.collections || [];
                this.datasetCollection = data?.current_collection || null;
                this.selectedCollectionId = data?.selected_collection_id || this.datasetCollection?.id || '';
                this.qaDatasets = data?.datasets || [];
                this.selectedDatasetId = data?.current_dataset?.id || '';
                this.qaItems = data?.items || [];
                this.evidenceChunks = data?.chunks || [];
                this.datasetSummary = data?.summary || {};
                this.datasetForm.collection_id = this.selectedCollectionId || '';
                if (data?.selection_error) {
                    this.datasetError = data.selection_error;
                    this.selectedQaItemId = '';
                    this.selectedChunk = null;
                    this.qaForm = this.emptyQaForm();
                }
                if (this.selectedQaItemId) {
                    const item = this.qaItems.find((row: any) => row.id === this.selectedQaItemId);
                    if (item) this.fillQaForm(item);
                    else this.selectedQaItemId = '';
                }
            } else {
                this.datasetError = data?.message || 'QA 후보를 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.datasetError = error?.message || 'QA 후보를 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            this.datasetLoading = false;
            await this.service.render();
        }
    }

    public async createQaDataset() {
        const name = String(this.datasetForm.name || '').trim();
        const collectionId = String(this.datasetForm.collection_id || this.selectedCollectionId || '').trim();
        if (!name || this.datasetSaving) return;
        if (!collectionId) {
            await this.service.modal.error('QA 후보를 만들 컬렉션을 선택하세요.');
            return;
        }
        const selected = this.collections.find((row: any) => row.id === collectionId) || this.datasetCollection;
        if (selected && !this.collectionQaAvailable(selected)) {
            await this.service.modal.error('준비 완료된 근거 자료가 있는 컬렉션만 QA 후보를 만들 수 있습니다.');
            return;
        }
        this.datasetSaving = true;
        this.datasetError = '';
        this.datasetMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create_qa_dataset", {
                name,
                description: this.datasetForm.description || '',
                collection_id: collectionId,
            });
            if (code === 200) {
                this.selectedCollectionId = data?.dataset?.collection_id || collectionId;
                this.datasetCollection = data?.collection || this.datasetCollection;
                this.selectedDatasetId = data?.dataset?.id || '';
                this.datasetForm = { name: '', description: '', collection_id: this.selectedCollectionId };
                this.showDatasetForm = false;
                this.datasetMessage = 'QA 후보를 생성했습니다.';
                await this.loadDatasetAuthoring();
            } else {
                this.datasetError = data?.message || 'QA 후보 생성에 실패했습니다.';
            }
        } catch (error: any) {
            this.datasetError = error?.message || 'QA 후보 생성에 실패했습니다.';
        } finally {
            this.datasetSaving = false;
            await this.service.render();
        }
    }

    public async generateQaCandidates() {
        if (this.candidateGenerating) return;
        if (!this.selectedCollectionId) {
            await this.service.modal.error('QA 후보를 생성할 컬렉션을 선택하세요.');
            return;
        }
        const selected = this.selectedDatasetCollection();
        if (this.collectionDeletionRequested(selected)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 QA 후보를 만들 수 없습니다.');
            return;
        }
        if (selected && !this.collectionQaAvailable(selected)) {
            await this.service.modal.error('준비 완료된 근거 자료가 있는 컬렉션만 QA 후보를 만들 수 있습니다.');
            return;
        }
        if (!this.collectionHasEvidenceReady()) {
            await this.service.modal.error('선택한 컬렉션에 준비 완료된 근거 자료가 없습니다.');
            return;
        }

        this.candidateGenerating = true;
        this.datasetError = '';
        this.datasetMessage = '';
        this.candidateResult = null;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("generate_qa_candidates", {
                collection_id: this.selectedCollectionId,
                dataset_id: this.selectedDatasetId || '',
                limit: this.candidateLimit || 200,
            });
            if (code === 200) {
                this.candidateResult = data?.result || {};
                this.selectedDatasetId = data?.dataset?.id || this.candidateResult?.dataset_id || this.selectedDatasetId || '';
                this.datasetCollection = data?.collection || this.datasetCollection;
                this.datasetMessage = `QA 후보를 생성했습니다. ${this.candidateResultLabel()}`;
                await this.loadDatasetAuthoring();
            } else {
                this.datasetError = data?.message || 'QA 후보 생성에 실패했습니다.';
            }
        } catch (error: any) {
            this.datasetError = error?.message || 'QA 후보 생성에 실패했습니다.';
        } finally {
            this.candidateGenerating = false;
            await this.service.render();
        }
    }

    public async selectQaDataset(dataset: any) {
        if (!dataset?.id) {
            this.selectedDatasetId = '';
            this.selectedQaItemId = '';
            this.selectedChunk = null;
            this.candidateResult = null;
            this.qaForm = { ...this.emptyQaForm(), collection_id: this.selectedCollectionId };
            await this.loadDatasetAuthoring();
            return;
        }
        if (dataset.id === this.selectedDatasetId) return;
        const found = this.qaDatasets.find((row: any) => row.id === dataset.id);
        if (found?.collection_id) this.selectedCollectionId = found.collection_id;
        this.selectedDatasetId = dataset.id;
        this.selectedQaItemId = '';
        this.candidateResult = null;
        this.qaForm = { ...this.emptyQaForm(), collection_id: this.selectedCollectionId };
        this.selectedChunk = null;
        await this.loadDatasetAuthoring();
    }

    public async startNewQa() {
        const datasetId = this.selectedDatasetId || '';
        if (!this.selectedCollectionId) {
            await this.service.modal.error('QA 항목을 만들 컬렉션을 먼저 선택하세요.');
            return;
        }
        if (this.collectionDeletionRequested(this.selectedDatasetCollection())) {
            await this.service.modal.error('폐기 요청된 컬렉션은 QA 항목을 만들 수 없습니다.');
            return;
        }
        if (!datasetId) {
            await this.service.modal.error('QA 항목을 저장할 QA 후보를 선택하세요.');
            return;
        }
        this.selectedQaItemId = '';
        this.selectedChunk = null;
        this.qaForm = { ...this.emptyQaForm(), dataset_id: datasetId, collection_id: this.selectedCollectionId };
        await this.service.render();
    }

    public fillQaForm(item: any) {
        if (!item) return;
        const split = item.eval_usage || (item.golden_status ? 'golden' : 'train');
        this.selectedQaItemId = item.id || '';
        this.qaForm = {
            id: item.id || '',
            dataset_id: item.dataset_id || this.selectedDatasetId || '',
            collection_id: item.collection_id || this.selectedCollectionId || '',
            item_type: item.item_type || 'qa',
            difficulty: item.difficulty || 'medium',
            split: split || 'train',
            status: item.status || 'draft',
            domain: item.domain || '',
            question: item.question || '',
            answer: item.answer || '',
            instruction: item.instruction || '선택한 근거만 사용해 답변하세요.',
            reason: item.reason || '',
            source_document_id: item.source_document_id || '',
            source_chunk_id: item.source_chunk_id || '',
            evidence_ids: item.evidence_ids_list || [],
            input_text: item.input_text || item.chunk_text || '',
        };
        this.selectedChunk = item.source_chunk_id ? {
            id: item.source_chunk_id,
            collection_id: item.collection_id || this.selectedCollectionId || '',
            collection_title: item.collection_title || '',
            document_id: item.source_document_id,
            evidence_id: (item.evidence_ids_list || [])[0] || item.evidence_id || '',
            document_title: item.document_title || '',
            relative_dir: item.relative_dir || '',
            page_no: item.page_no || 0,
            chunk_index: item.chunk_index || 0,
            text: item.chunk_text || item.input_text || '',
        } : null;
    }

    public async editQaItem(item: any) {
        this.fillQaForm(item);
        await this.service.render();
    }

    public async selectEvidenceChunk(chunk: any) {
        if (!chunk) return;
        if (!this.selectedCollectionId) {
            await this.service.modal.error('근거를 확인할 컬렉션을 먼저 선택하세요.');
            return;
        }
        if (!chunk.collection_id || chunk.collection_id !== this.selectedCollectionId) {
            await this.service.modal.error('선택한 컬렉션의 근거만 연결할 수 있습니다.');
            return;
        }
        this.selectedChunk = chunk;
        this.qaForm.source_document_id = chunk.document_id || '';
        this.qaForm.source_chunk_id = chunk.id || '';
        this.qaForm.evidence_ids = chunk.evidence_id ? [chunk.evidence_id] : [];
        this.qaForm.input_text = chunk.text || '';
        await this.service.render();
    }

    public async clearEvidence() {
        this.selectedChunk = null;
        this.qaForm.source_document_id = '';
        this.qaForm.source_chunk_id = '';
        this.qaForm.evidence_ids = [];
        this.qaForm.input_text = '';
        await this.service.render();
    }

    public async applyChunkToAnswer() {
        if (!this.selectedChunk?.text) return;
        this.qaForm.answer = this.selectedChunk.text;
        await this.service.render();
    }

    public async saveQaItem() {
        if (this.datasetSaving) return;
        const datasetId = this.qaForm.dataset_id || this.selectedDatasetId || '';
        if (!this.selectedCollectionId) {
            await this.service.modal.error('QA 후보 컬렉션을 선택하세요.');
            return;
        }
        if (this.collectionDeletionRequested(this.selectedDatasetCollection())) {
            await this.service.modal.error('폐기 요청된 컬렉션은 QA 항목을 저장할 수 없습니다.');
            return;
        }
        if (!datasetId) {
            await this.service.modal.error('저장할 QA 후보를 선택하세요.');
            return;
        }
        if (!this.qaForm.source_chunk_id) {
            await this.service.modal.error('선택한 컬렉션의 준비 완료 근거 자료를 선택하세요.');
            return;
        }
        if (!String(this.qaForm.question || '').trim() || !String(this.qaForm.answer || '').trim()) {
            await this.service.modal.error('질문과 답변을 입력하세요.');
            return;
        }

        this.datasetSaving = true;
        this.datasetError = '';
        this.datasetMessage = '';
        await this.service.render();

        const payload = { ...this.qaForm, dataset_id: datasetId, collection_id: this.selectedCollectionId };
        try {
            const { code, data } = await wiz.call("save_qa_item", {
                form: JSON.stringify(payload),
            });
            if (code === 200) {
                this.selectedDatasetId = data?.dataset?.id || datasetId;
                this.selectedQaItemId = data?.item?.id || '';
                this.datasetMessage = 'QA 항목을 저장했습니다.';
                await this.loadDatasetAuthoring();
            } else {
                this.datasetError = data?.message || 'QA 항목 저장에 실패했습니다.';
            }
        } catch (error: any) {
            this.datasetError = error?.message || 'QA 항목 저장에 실패했습니다.';
        } finally {
            this.datasetSaving = false;
            await this.service.render();
        }
    }

    public async requestQaReview(scope: string = 'item') {
        if (this.datasetReviewing) return;
        const datasetId = this.selectedDatasetId || this.qaForm.dataset_id || '';
        const itemId = scope === 'item' ? (this.selectedQaItemId || this.qaForm.id || '') : '';
        if (!datasetId) {
            await this.service.modal.error('검수 요청할 QA 후보를 선택하세요.');
            return;
        }
        if (scope === 'item' && !itemId) {
            await this.service.modal.error('검수 요청할 QA 항목을 선택하세요.');
            return;
        }
        if (this.collectionDeletionRequested(this.selectedDatasetCollection())) {
            await this.service.modal.error('폐기 요청된 컬렉션의 QA 항목은 검수로 넘길 수 없습니다.');
            return;
        }
        if (!this.reviewRequestable()) {
            await this.service.modal.error(this.reviewRequestReason());
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '검수 요청',
            message: scope === 'dataset' ? '현재 QA 후보의 검수 가능 항목을 검수 요청으로 전환합니다.' : '선택한 QA 항목을 검수 요청으로 전환합니다.',
            action: '요청',
            cancel: '취소',
            status: 'success',
            actionBtn: 'success',
        });
        if (!confirmed) return;

        this.datasetReviewing = true;
        this.datasetError = '';
        this.datasetMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("request_qa_review", {
                dataset_id: datasetId,
                item_id: itemId,
                limit: scope === 'dataset' ? 200 : 1,
            });
            if (code === 200) {
                const result = data?.result || {};
                this.datasetMessage = `검수 요청 ${this.number(result.created_count)}건을 등록했습니다.`;
                await this.loadDatasetAuthoring();
            } else {
                this.datasetError = data?.message || '검수 요청에 실패했습니다.';
            }
        } catch (error: any) {
            this.datasetError = error?.message || '검수 요청에 실패했습니다.';
        } finally {
            this.datasetReviewing = false;
            await this.service.render();
        }
    }

    public async refreshEvidenceSearch() {
        if (!this.selectedCollectionId) {
            this.evidenceChunks = [];
            await this.service.modal.error('근거를 확인할 컬렉션을 먼저 선택하세요.');
            await this.service.render();
            return;
        }
        await this.loadDatasetAuthoring();
    }

    public itemTypeLabel(type: string) {
        const option = this.itemTypeOptions.find((item: any) => item.key === type);
        return option ? option.label : (type || '-');
    }

    public difficultyLabel(value: string) {
        const option = this.difficultyOptions.find((item: any) => item.key === value);
        return option ? option.label : (value || '-');
    }

    public splitLabel(value: string) {
        const option = this.splitOptions.find((item: any) => item.key === value);
        return option ? option.label : (value || '-');
    }

    public pageNoLabel(value: any) {
        return value ? `${value}쪽` : '-쪽';
    }

    public evidenceLabel(item: any) {
        if (!item?.source_chunk_id) return '근거 자료 없음';
        const page = this.pageNoLabel(item.page_no);
        const index = item.chunk_index || item.chunk_index === 0 ? `근거 자료 번호 ${item.chunk_index}` : '근거 자료 번호 -';
        return `${page} · ${index}`;
    }

    public reviewableCount() {
        return Number(this.datasetSummary?.reviewable_count || 0);
    }

    public reviewFlowCount() {
        return Number(this.datasetSummary?.review_requested_count || 0)
            + Number(this.datasetSummary?.assigned_count || 0)
            + Number(this.datasetSummary?.in_review_count || 0);
    }

    public qaItemClass(item: any) {
        return this.selectedQaItemId === item?.id
            ? 'border-emerald-300 bg-emerald-50'
            : 'border-gray-200 bg-white hover:bg-gray-50';
    }

    public splitTone(split: string) {
        switch (split) {
            case 'train':
                return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'eval':
                return 'border-violet-200 bg-violet-50 text-violet-700';
            case 'golden':
                return 'border-amber-200 bg-amber-50 text-amber-800';
            default:
                return 'border-gray-200 bg-gray-50 text-gray-600';
        }
    }

    public async createFolder() {
        if (!this.current?.id || !this.newFolderName.trim()) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 폴더를 만들 수 없습니다.');
            return;
        }
        this.driveLoading = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create_folder", {
                collection_id: this.current.id,
                folder_id: this.currentFolderId || '',
                path: this.currentPath || '',
                name: this.newFolderName.trim(),
            });
            if (code === 200) {
                this.newFolderName = '';
                this.driveActionMenuOpen = false;
                this.showNewFolderForm = false;
                this.assignDrive(data || {});
            } else {
                this.error = data?.message || '폴더를 생성하지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '폴더를 생성하지 못했습니다.';
        } finally {
            this.driveLoading = false;
            await this.service.render();
        }
    }

    public async toggleDriveActionMenu() {
        if (!this.current?.id || this.uploading || this.driveLoading) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 자료를 추가할 수 없습니다.');
            return;
        }
        this.driveActionMenuOpen = !this.driveActionMenuOpen;
        if (!this.driveActionMenuOpen) {
            this.showNewFolderForm = false;
        }
        await this.service.render();
    }

    public async closeDriveActionMenu() {
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.service.render();
    }

    public async showNewFolderAction() {
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 폴더를 만들 수 없습니다.');
            return;
        }
        this.driveActionMenuOpen = false;
        this.newFolderName = '';
        this.showNewFolderForm = true;
        await this.service.render();
    }

    public async closeNewFolderForm() {
        if (this.driveLoading) return;
        this.showNewFolderForm = false;
        this.newFolderName = '';
        await this.service.render();
    }

    public async selectDriveUploadAction(mode: string) {
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.service.render();
        await this.uploadFiles(mode);
    }

    public async uploadFiles(mode: string = 'file') {
        if (!this.current?.id || this.uploading) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 파일을 업로드할 수 없습니다.');
            return;
        }
        let selected: any = [];
        try {
            selected = mode === 'folder'
                ? await this.service.file.select({ type: 'folder' })
                : await this.service.file.select();
        } catch (error) {
            return;
        }
        await this.uploadSelected(selected);
    }

    public async uploadDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.current?.id || this.uploading) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 파일을 업로드할 수 없습니다.');
            return;
        }
        const files = await this.service.file.drop(event);
        await this.uploadSelected(files);
    }

    public preventDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
    }

    public async uploadSelected(files: any) {
        const list: any[] = Array.from(files || []);
        if (!list.length || !this.current?.id) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 파일을 업로드할 수 없습니다.');
            return;
        }

        const fd = new FormData();
        const filepath: string[] = [];
        for (let i = 0; i < list.length; i++) {
            const file: any = list[i];
            const relpath = file.filepath || file.webkitRelativePath || file.name;
            filepath.push(relpath || file.name);
            fd.append('file[]', file);
        }
        fd.append('filepath', JSON.stringify(filepath));
        fd.append('collection_id', this.current.id);
        fd.append('folder_id', this.currentFolderId || '');
        fd.append('path', this.currentPath || '');

        this.uploading = true;
        this.uploadStatus = { uploading: true, percent: 0 };
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const result: any = await this.service.file.upload(wiz.url('upload'), fd, this.uploadProgress.bind(this));
            const code = result?.code;
            const data = result?.data || {};
            if (code === 200) {
                this.assignDrive(data);
                const uploaded = data.uploaded || [];
                const registered = uploaded.filter((item: any) => item?.registered).length;
                this.uploadMessage = registered > 0
                    ? `${this.number(uploaded.length)}개 파일을 업로드하고 ${this.number(registered)}개 자료를 등록했습니다.`
                    : `${this.number(uploaded.length)}개 파일을 업로드했습니다.`;
            } else {
                this.error = data?.message || '파일 업로드에 실패했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '파일 업로드에 실패했습니다.';
        } finally {
            this.uploading = false;
            this.uploadStatus = { uploading: false, percent: 0 };
            await this.service.render();
        }
    }

    public async uploadProgress(percent: number) {
        this.uploadStatus = {
            uploading: percent > 0 && percent < 100,
            percent: Math.max(0, Math.min(100, Number(percent || 0))),
        };
        await this.service.render();
    }

    public number(value: any) {
        return Number(value || 0).toLocaleString();
    }

    public fileSize(value: any) {
        const bytes = Number(value || 0);
        if (bytes >= 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024 / 1024).toFixed(1)} GB`;
        if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
        if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${bytes} B`;
    }

    public pathLabel() {
        return this.currentPath ? `/${this.currentPath}` : '/';
    }

    public extensionLabel(file: any) {
        return (file?.extension || 'file').toUpperCase();
    }

    public roleLabel(file: any) {
        const role = this.classifyFile(file).role;
        switch (role) {
            case 'source':
                return '원본 자료';
            case 'metadata':
                return '자료 정보';
            case 'ocr':
                return '텍스트 자료';
            case 'embedding':
                return '근거 자료';
            case 'vector':
                return '근거 색인';
            case 'status':
                return '점검 상태';
            case 'ocr_status':
            case 'embedding_status':
                return '처리 상태 자료';
            case 'vector_status':
                return '근거 색인 상태';
            default:
                return file?.file_role || '보조 파일';
        }
    }

    public statusLabel(status: string) {
        switch (status) {
            case 'usable':
                return '사용 가능';
            case 'partial':
            case 'partial_ready':
            case 'partially_ready':
                return '부분 준비';
            case 'processing':
                return '처리 중';
            case 'preserved':
                return '원본 보존';
            case 'linked':
                return '연결됨';
            case 'active':
                return '운영 중';
            case 'registered':
                return '처리 완료';
            case 'unregistered':
                return '자료 정보 생성 전';
            case 'ready':
                return '검수 준비';
            case 'draft':
                return '초안';
            case 'candidate':
                return '후보';
            case 'review_requested':
                return '검수 요청';
            case 'assigned':
                return '배정됨';
            case 'in_review':
                return '검수 중';
            case 'approved':
                return '승인';
            case 'rejected':
                return '반려';
            case 'change_requested':
                return '수정 요청';
            case 'not_requested':
                return '요청 전';
            case 'not_created':
                return '생성 전';
            case 'gate_ready':
                return '검수 가능';
            case 'train':
                return '작성용';
            case 'eval':
                return '평가용';
            case 'golden':
                return '골든셋';
            case 'queued':
                return '대기';
            case 'running':
                return '실행 중';
            case 'passed':
                return '통과';
            case 'published':
                return '게시';
            case 'blocked':
                return '보류';
            case 'working':
                return '처리 중';
            case 'attention':
                return '확인 필요';
            case 'unavailable':
                return '생성 불가';
            case 'empty':
                return '정보 없음';
            case 'completed':
            case 'indexed':
            case 'imported':
            case 'done':
                return '완료';
            case 'pending':
            case 'discovered':
            case 'new':
            case 'unchecked':
            case 'unknown':
                return '대기';
            case 'source':
            case 'exists':
                return '존재';
            case 'failed':
            case 'error':
                return '오류';
            case 'missing':
                return '누락';
            default:
                return status || 'unknown';
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case 'ready':
            case 'usable':
            case 'completed':
            case 'indexed':
            case 'imported':
            case 'done':
            case 'passed':
            case 'published':
            case 'draft':
            case 'candidate':
            case 'registered':
            case 'preserved':
            case 'linked':
            case 'active':
            case 'approved':
            case 'gate_ready':
            case 'source':
            case 'metadata':
            case 'exists':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'partial':
            case 'partial_ready':
            case 'partially_ready':
                return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'working':
            case 'processing':
            case 'queued':
            case 'running':
            case 'pending':
            case 'review_requested':
            case 'assigned':
            case 'in_review':
            case 'not_requested':
            case 'discovered':
            case 'new':
            case 'unchecked':
            case 'unregistered':
            case 'unknown':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'attention':
            case 'failed':
            case 'error':
            case 'missing':
            case 'blocked':
            case 'rejected':
            case 'change_requested':
                return 'border-rose-200 bg-rose-50 text-rose-700';
            case 'unavailable':
            case 'not_created':
                return 'border-gray-200 bg-gray-50 text-gray-600';
            default:
                return 'border-gray-200 bg-gray-50 text-gray-600';
        }
    }

    public metricTone(tone: string) {
        switch (tone) {
            case 'emerald':
                return 'border-emerald-200 bg-emerald-50 text-emerald-800';
            case 'sky':
                return 'border-sky-200 bg-sky-50 text-sky-800';
            case 'amber':
                return 'border-amber-200 bg-amber-50 text-amber-800';
            case 'rose':
                return 'border-rose-200 bg-rose-50 text-rose-800';
            default:
                return 'border-gray-200 bg-white text-gray-800';
        }
    }

    public pipelineTone(tone: string) {
        switch (tone) {
            case 'emerald':
                return 'border-emerald-200 bg-emerald-50 text-emerald-900';
            case 'amber':
                return 'border-amber-200 bg-amber-50 text-amber-900';
            case 'rose':
                return 'border-rose-200 bg-rose-50 text-rose-900';
            case 'sky':
                return 'border-sky-200 bg-sky-50 text-sky-900';
            default:
                return 'border-gray-200 bg-gray-50 text-gray-800';
        }
    }

    public slotTone(slot: any) {
        if (!slot?.files?.length) return 'border-gray-200 bg-gray-50 text-gray-400';
        switch (slot.key) {
            case 'source':
            case 'metadata':
                return 'border-sky-200 bg-sky-50 text-sky-800';
            case 'ocr':
                return 'border-amber-200 bg-amber-50 text-amber-800';
            case 'embedding':
                return 'border-violet-200 bg-violet-50 text-violet-800';
            case 'vector':
                return 'border-emerald-200 bg-emerald-50 text-emerald-800';
            case 'ocr_status':
            case 'embedding_status':
            case 'vector_status':
            case 'status':
                return 'border-emerald-200 bg-emerald-50 text-emerald-800';
            default:
                return 'border-gray-200 bg-white text-gray-800';
        }
    }

    public fileTone(file: any) {
        const ext = (file?.extension || '').toLowerCase();
        if (['pdf'].includes(ext)) return 'border-rose-100 bg-rose-50 text-rose-700';
        if (['xlsx', 'xls', 'csv'].includes(ext)) return 'border-emerald-100 bg-emerald-50 text-emerald-700';
        if (['doc', 'docx', 'hwp', 'hwpx'].includes(ext)) return 'border-sky-100 bg-sky-50 text-sky-700';
        if (['json', 'xml'].includes(ext)) return 'border-violet-100 bg-violet-50 text-violet-700';
        return 'border-gray-100 bg-gray-50 text-gray-600';
    }
}

export default PageQaComponent;